// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"37CyT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _index = require("./pages/index");
var _index1 = require("./global/index");
var _indexDefault = parcelHelpers.interopDefault(_index1);
const main = ()=>{
    (0, _index.initScriptPage)();
    (0, _indexDefault.default)();
};
window.onload = ()=>{
    main();
};

},{"./pages/index":"UVSeH","./global/index":"ku2ku","@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"UVSeH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VIEWS", ()=>VIEWS);
parcelHelpers.export(exports, "initScriptPage", ()=>initScriptPage);
var _index = require("./home/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _success = require("./payment/success");
var _successDefault = parcelHelpers.interopDefault(_success);
var _index1 = require("./term/index");
var _indexDefault1 = parcelHelpers.interopDefault(_index1);
var _thankyou = require("./thank-you/thankyou");
var _thankyouDefault = parcelHelpers.interopDefault(_thankyou);
const VIEWS = [
    (0, _indexDefault.default),
    (0, _successDefault.default),
    (0, _indexDefault1.default),
    (0, _thankyouDefault.default)
];
const initScriptPage = ()=>{
    const dataNamespace = $('[data-barba-namespace]').attr('data-barba-namespace');
    VIEWS.forEach((page)=>{
        if (dataNamespace == page.namespace) page.afterEnter();
    });
};

},{"./home/index":"72hFl","./payment/success":"l135N","./term/index":"2cZNX","./thank-you/thankyou":"jlU6O","@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"72hFl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../../helper/index");
var _viewport = require("../../helper/viewport");
var _lenis = require("../../global/lenis");
var _splitText = require("../../libs/SplitText");
const home = {
    namespace: "home",
    afterEnter (data) {
        console.log(`enter ${this.namespace}`);
        let cont = $("body");
        function headerAnim() {
            let headTxt = new (0, _splitText.SplitText)(".home-hero-title", (0, _index.typeOpts).words);
            let scheduleTxt = new (0, _splitText.SplitText)(".header-main-schedule", (0, _index.typeOpts).chars);
            let tlSplitHead = gsap.timeline({
                onStart: ()=>{
                    $('[data-init-df]').removeAttr('data-init-df');
                },
                onComplete: ()=>{
                    headTxt.revert();
                    scheduleTxt.revert();
                }
            });
            tlSplitHead.from(".home-hero-logo", {
                yPercent: 60,
                autoAlpha: 0,
                duration: 1,
                ease: "power2.out"
            }, 0).from(headTxt.words, {
                yPercent: 60,
                autoAlpha: 0,
                stagger: 0.03,
                duration: 0.6,
                ease: "power2.out"
            }, "<=.2");
            if ($(window).width() > 767) tlSplitHead.from(".home-hero-btn", {
                yPercent: 60,
                autoAlpha: 0,
                duration: 0.6,
                ease: "power2.out"
            }, "<=.4").from(".home-hero-discover", {
                autoAlpha: 0,
                duration: 0.6,
                ease: "power2.out"
            }, "<=.2").from(scheduleTxt.chars, {
                yPercent: 60,
                autoAlpha: 0,
                stagger: 0.01,
                duration: 0.8,
                ease: "power2.out"
            }, "<=0");
            tlSplitHead.from(".header-main-inner", {
                autoAlpha: 0,
                duration: 0.6,
                ease: "power2.out"
            }, "<=.2");
        }
        headerAnim();
        function initAccordion(wrap) {
            const parent = (0, _index.selector)(wrap);
            const DOM = {
                accordion: parent(".accordion"),
                accordionTitle: parent(".accordion-title"),
                accordionContent: parent(".accordion-content")
            };
            parent(DOM.accordionContent).hide();
            function activeAccordion(index) {
                DOM.accordionContent.eq(index).slideToggle("slow");
                DOM.accordion.eq(index).toggleClass("active");
                DOM.accordionContent.not(DOM.accordionContent.eq(index)).slideUp("slow");
                DOM.accordion.not(DOM.accordion.eq(index)).removeClass("active");
            }
            DOM.accordionTitle.on("click", function() {
                let index = $(this).parent().index();
                activeAccordion(index);
                gsap.globalTimeline.getChildren().filter((e)=>e.data === "footer-curtain").forEach((el)=>{
                    setTimeout(()=>{
                        el.scrollTrigger.refresh();
                    }, 500);
                });
            });
        }
        function heroParallax() {
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: cont.find(".home-hero"),
                    start: "top top",
                    end: "bottom top",
                    scrub: 0.3
                }
            });
            tl.to(cont.find(".home-hero-bg img"), {
                y: "19rem",
                ease: "none"
            });
        }
        heroParallax();
        /** (💡)  - BENEFIT */ // function homeBenefit() {
        //   function stackScroll() {
        //     const BENEFIT = {
        //       stage: $(".home-benefit"),
        //       wrap: $(".home-benefit--wrap"),
        //       list: $(".home-benefit-list"),
        //       item: $(".home-benefit-item"),
        //       mainItem: $(".home-benefit-main"),
        //       otherItem: $(".home-benefit-other"),
        //       otherWrap: $(".home-benefit-other-wrap"),
        //     };
        //     let mainItemSelect = selector(BENEFIT.mainItem);
        //     let totalDistance =
        //       BENEFIT.mainItem.width() +
        //       BENEFIT.otherItem.width() * BENEFIT.otherItem.length;
        //     let otherWrapDistance = BENEFIT.mainItem.outerWidth();
        //     // const ITEM_WIDTH = ($('.container').width() - percentage(37, $('.container').width())) / viewportBreak({ desktop: 5, tablet: 2 });
        //     const ITEM_WIDTH =
        //       ($(BENEFIT.otherItem).outerWidth() * (BENEFIT.otherItem.length - 1) -
        //         ($(".container").width() -
        //           $(BENEFIT.otherItem).last().outerWidth())) /
        //       (BENEFIT.otherItem.length - 1);
        //     if ($(window).width() > 991) {
        //       gsap.set(BENEFIT.stage, {
        //         height: totalDistance * 1.2 + cvUnit(100, "rem"),
        //       });
        //     }
        //     let scrollerTl = gsap.timeline({
        //       defaults: { ease: "none" },
        //       scrollTrigger: {
        //         trigger: BENEFIT.stage,
        //         start: `top-=${$("header").outerHeight()} top`,
        //         end: "bottom bottom",
        //         scrub: 0.6,
        //       },
        //     });
        //     scrollerTl
        //       .to(
        //         mainItemSelect("h2"),
        //         {
        //           scale: 0.56,
        //           transformOrigin: "top left",
        //           ease: "linear",
        //           duration: 1,
        //         },
        //         0
        //       )
        //       .to(
        //         mainItemSelect("p"),
        //         {
        //           marginTop: -cvUnit(
        //             viewportBreak({ desktop: 140, tablet: 50 }),
        //             "rem"
        //           ),
        //           scale: 0.8,
        //           duration: 1,
        //         },
        //         0
        //       )
        //       .to(
        //         mainItemSelect(".home-benefit-main-btn"),
        //         {
        //           scale: 0.8,
        //           duration: 1,
        //         },
        //         0
        //       )
        //       .to(
        //         BENEFIT.otherWrap,
        //         {
        //           x: -otherWrapDistance,
        //           duration: 1,
        //         },
        //         0
        //       );
        //     BENEFIT.otherItem.each((index, item) => {
        //       let itemSelect = selector(item);
        //       gsap.set(itemSelect(".home-benefit-item-overlay"), { scaleX: 0 });
        //       let label = $(item)
        //         .find(".home-benefit-other-title")
        //         .text()
        //         .toLowerCase()
        //         .replace(" ", "-");
        //       $(item).attr("data-label", `${label}`);
        //       scrollerTl
        //         .add(`label${index}`)
        //         .to(item, {
        //           duration: 1,
        //         })
        //         .to(
        //           itemSelect("h3"),
        //           {
        //             scale: viewportBreak({ desktop: 0.75, tablet: 0.5 }),
        //             transformOrigin: "top left",
        //             duration: 1,
        //           },
        //           "<=0"
        //         )
        //         .to(
        //           itemSelect(".home-benefit-item-overlay"),
        //           {
        //             scaleX: 1,
        //             transformOrigin: "right",
        //             duration: 1,
        //           },
        //           "<=0"
        //         )
        //         .to(
        //           itemSelect("p"),
        //           {
        //             autoAlpha: 0,
        //             duration: 1,
        //           },
        //           "<=0.2"
        //         )
        //         .to(
        //           itemSelect(".home-benefit-other-img"),
        //           {
        //             autoAlpha: 0,
        //             duration: 1,
        //             scale: 0.6,
        //           },
        //           "<=0.2"
        //         );
        //       BENEFIT.otherItem.each((idx, el) => {
        //         if (idx > index) {
        //           scrollerTl.to(
        //             el,
        //             {
        //               x: -(ITEM_WIDTH * (index + 1)),
        //               paddingLeft: viewportBreak({
        //                 desktop: cvUnit(40, "rem"),
        //                 tablet: cvUnit(24, "rem"),
        //               }),
        //               duration: 1,
        //             },
        //             "<=0"
        //           );
        //         }
        //       });
        //     });
        //     scrollerTl
        //       .to(
        //         BENEFIT.wrap,
        //         {
        //           scale: viewportBreak({ desktop: 0.5, tablet: 0.8 }),
        //           autoAlpha: 0,
        //           duration: 2,
        //         },
        //         ">=-.8"
        //       )
        //       .to(
        //         BENEFIT.wrap,
        //         {
        //           yPercent: -8,
        //           duration: 1,
        //         },
        //         "<= .8"
        //       );
        //     $(".home-benefit-other-sub-btn").on("click", function (e) {
        //       e.preventDefault();
        //       let target = $(this)
        //         .closest(".home-benefit-item.home-benefit-other")
        //         .index();
        //       toLabel(1, scrollerTl, `label${target}`);
        //     });
        //     function toLabel(duration, timeline, label) {
        //       lenis.stop();
        //       const yStart =
        //         $(".home-benefit").offset().top - $(".header").outerHeight();
        //       const now = timeline.progress();
        //       timeline.seek(label);
        //       const goToProgress = timeline.progress();
        //       timeline.progress(now);
        //       lenis.scrollTo(
        //         yStart +
        //           (timeline.scrollTrigger.end - timeline.scrollTrigger.start) *
        //             goToProgress,
        //         {
        //           duration: duration,
        //           force: true,
        //         }
        //       );
        //     }
        //   }
        //   function animText() {
        //     let mainTitleTxt = new SplitText(
        //       ".home-benefit-main-title",
        //       typeOpts.words
        //     );
        //     let mainSubTxt = new SplitText(
        //       ".home-benefit-main-sub",
        //       typeOpts.words
        //     );
        //     let tlSplitHead = gsap.timeline({
        //       scrollTrigger: {
        //         trigger: ".home-benefit-list",
        //         start: "top bottom-=10%",
        //         // markers: true
        //       },
        //       onComplete: () => {
        //         mainTitleTxt.revert();
        //         mainSubTxt.revert();
        //       },
        //     });
        //     tlSplitHead
        //       .from(
        //         mainTitleTxt.words,
        //         {
        //           yPercent: 60,
        //           autoAlpha: 0,
        //           stagger: 0.03,
        //           duration: 0.6,
        //           ease: "power2.out",
        //         },
        //         0
        //       )
        //       .from(
        //         mainSubTxt.words,
        //         {
        //           yPercent: 60,
        //           autoAlpha: 0,
        //           stagger: 0.03,
        //           duration: 0.6,
        //           ease: "power2.out",
        //         },
        //         "<=.4"
        //       );
        //     $(".home-benefit-other").each((idx, el) => {
        //       if (idx < 3) {
        //         let otherTitleTxt = new SplitText(
        //           $(el).find(".home-benefit-other-title"),
        //           typeOpts.chars
        //         );
        //         let otherSubTxt = new SplitText(
        //           $(el).find(".home-benefit-other-sub-txt"),
        //           typeOpts.words
        //         );
        //         tlSplitHead
        //           .from(
        //             otherTitleTxt.chars,
        //             {
        //               yPercent: 60,
        //               autoAlpha: 0,
        //               stagger: 0.01,
        //               duration: 0.6,
        //               ease: "power2.out",
        //               onComplete: () => {
        //                 otherTitleTxt.revert();
        //               },
        //             },
        //             0
        //           )
        //           .from(
        //             otherSubTxt.words,
        //             {
        //               yPercent: 60,
        //               autoAlpha: 0,
        //               stagger: 0.03,
        //               duration: 0.6,
        //               ease: "power2.out",
        //               onComplete: () => {
        //                 otherSubTxt.revert();
        //               },
        //             },
        //             "<=.2"
        //           );
        //       }
        //     });
        //   }
        //   animText();
        //   if ($(window).width() > 767) {
        //     stackScroll();
        //   }
        // }
        // homeBenefit();
        /** (💡)  - SHOWREEL */ function homeShowreel() {
            function galleryZoom() {
                const GALLERY = {
                    wrap: $(".home-showreel"),
                    item: ({ wrap, item })=>GALLERY.otherWrap.eq(wrap).find(GALLERY.otherInner).eq(item),
                    mainWrap: $(".home-showreel-main--inner"),
                    mainInner: $(".home-showreel-item-main"),
                    otherWrap: $(".home-showreel-other--inner"),
                    otherInner: $(".home-showreel-item-other"),
                    thumbPlay: $(".home-showreel-play")
                };
                let showreelTl = gsap.timeline({
                    defaults: {
                        ease: "none"
                    },
                    scrollTrigger: {
                        trigger: GALLERY.wrap,
                        start: `top bottom`,
                        end: "bottom bottom",
                        scrub: 0.6
                    }
                });
                const getOtherItem = ({ wrap, item })=>GALLERY.otherWrap.eq(wrap).find(GALLERY.otherInner).eq(item);
                (0, _viewport.viewportBreak)({
                    tablet: ()=>{
                        gsap.set(GALLERY.mainWrap, {
                            padding: 0
                        });
                    }
                });
                showreelTl.to(".home-showreel-item-overlay", {
                    autoAlpha: 0,
                    duration: 0.15
                }).from([
                    getOtherItem({
                        wrap: 0,
                        item: 2
                    }),
                    getOtherItem({
                        wrap: 1,
                        item: 2
                    })
                ], {
                    y: 80,
                    duration: 0.2
                }, "<=0").from([
                    getOtherItem({
                        wrap: 0,
                        item: 1
                    }),
                    getOtherItem({
                        wrap: 1,
                        item: 1
                    })
                ], {
                    y: 200,
                    duration: 0.2
                }, "<=0").from([
                    getOtherItem({
                        wrap: 0,
                        item: 0
                    }),
                    getOtherItem({
                        wrap: 1,
                        item: 0
                    })
                ], {
                    y: 320,
                    duration: 0.2
                }, "<=0").fromTo(GALLERY.mainWrap, {
                    clipPath: `inset(14% 37.35% 14% 37.35% round ${(0, _viewport.cvUnit)(20, "rem")}px)`
                }, {
                    clipPath: `inset(0% 0% 0% 0% round ${(0, _viewport.cvUnit)(20, "rem")}px)`,
                    duration: 1
                }, ">=-0.1").to(GALLERY.otherInner.find(".img"), {
                    scale: 1.6,
                    duration: 1
                }, "<=0").to(getOtherItem({
                    wrap: 0,
                    item: 2
                }), {
                    xPercent: -255,
                    duration: 1
                }, "<=0").to(getOtherItem({
                    wrap: 0,
                    item: 1
                }), {
                    xPercent: -460,
                    duration: 1
                }, "<=0").to(getOtherItem({
                    wrap: 0,
                    item: 0
                }), {
                    xPercent: -760,
                    duration: 1
                }, "<=0").to(getOtherItem({
                    wrap: 1,
                    item: 2
                }), {
                    xPercent: 255,
                    duration: 1
                }, "<=0").to(getOtherItem({
                    wrap: 1,
                    item: 1
                }), {
                    xPercent: 460,
                    duration: 1
                }, "<=0").to(getOtherItem({
                    wrap: 1,
                    item: 0
                }), {
                    xPercent: 760,
                    duration: 1
                }, "<=0").from(GALLERY.thumbPlay, {
                    autoAlpha: 0,
                    y: 0,
                    duration: 0.5
                }, ">=-1").from(".home-showreel-play-wrapper", {
                    autoAlpha: 0,
                    y: 0,
                    duration: 0.5
                }, "<=0").from(".home-showreel-play-ic", {
                    scale: 0.8,
                    duration: 1
                }, "<=0").from(".home-showreel-play-ic svg", {
                    scale: 1.4,
                    duration: 1
                }, "<=0").from(".home-showreel-play-first", {
                    x: -(0, _viewport.cvUnit)(200, "rem"),
                    duration: 1
                }, "<=0").from(".home-showreel-play-last", {
                    x: (0, _viewport.cvUnit)(200, "rem"),
                    duration: 1
                }, "<=0");
            }
            function playShowreel() {
                let DOM = {
                    stage: $(".home-showreel"),
                    vid_wrap: $(".home-showreel--wrap"),
                    link_vid: $(".home-showreel-thumb-link"),
                    thumbnail: $(".home-showreel-thumb img"),
                    play: $(".home-showreel-play"),
                    video: $(".home-showreel-thumb-link-vid")
                };
                // Deferred load: start loading video after critical resources are done
                function loadVideoSource() {
                    let source = DOM.video.find("source");
                    if (source.attr("data-src")) {
                        source.attr("src", source.attr("data-src"));
                        source.removeAttr("data-src");
                        DOM.video.get(0).load();
                    }
                }
                if (document.readyState === "complete") {
                    if ("requestIdleCallback" in window) requestIdleCallback(loadVideoSource);
                    else setTimeout(loadVideoSource, 1000);
                } else window.addEventListener("load", function() {
                    if ("requestIdleCallback" in window) requestIdleCallback(loadVideoSource);
                    else setTimeout(loadVideoSource, 1000);
                });
                DOM.link_vid.on("click", function(e) {
                    e.preventDefault();
                    if ($(this).attr("data-video") == "to-play") {
                        $(this).attr("data-video", "to-pause");
                        let heightVidWrap = (0, _viewport.viewportBreak)({
                            desktop: DOM.vid_wrap.height(),
                            tablet: $(".home-showreel-main--inner").height()
                        });
                        let scrollTarget = DOM.stage.outerHeight() + DOM.stage.offset().top - $(window).height();
                        (0, _lenis.lenis).scrollTo(scrollTarget);
                        DOM.video.removeClass("hidden");
                        // Fallback: load if deferred load hasn't completed yet
                        loadVideoSource();
                        let vid = DOM.video.get(0);
                        if (vid.readyState >= 3) {
                            // Video ready — hide thumbnail and play immediately
                            DOM.thumbnail.removeClass("loading").addClass("hidden");
                            DOM.play.addClass("hidden");
                            vid.pause();
                            vid.play();
                        } else {
                            // Video still loading — dim thumbnail and show spinner
                            DOM.thumbnail.addClass("loading");
                            DOM.play.addClass("loading");
                            vid.addEventListener("canplay", function onCanPlay() {
                                DOM.thumbnail.removeClass("loading").addClass("hidden");
                                DOM.play.removeClass("loading").addClass("hidden");
                                vid.pause();
                                vid.play();
                                vid.removeEventListener("canplay", onCanPlay);
                            });
                        }
                    } else {
                        $(this).attr("data-video", "to-play");
                        // $('.home-hero-vid-thumbnail').removeClass('hidden')
                        // $('.home-hero-vid-video').addClass('hidden')
                        //$('.home-hero-vid-thumbnail').find('video').get(0).play()
                        DOM.play.removeClass("hidden loading");
                        DOM.thumbnail.removeClass("hidden loading");
                        DOM.video.get(0).pause();
                    }
                });
                $(".home-showreel-play-wrapper").on("click", function(e) {
                    e.preventDefault();
                    DOM.link_vid.trigger("click");
                });
            }
            function animShowreel() {
                const target = $(".home-showreel");
                let tlFade = gsap.timeline({
                    scrollTrigger: {
                        trigger: target,
                        start: "bottom top+=45%",
                        end: "bottom top-=40%",
                        scrub: 0.3
                    }
                });
            }
            animShowreel();
            playShowreel();
            if ($(window).width() > 767) galleryZoom();
        }
        homeShowreel();
        /** (💡)  - SERVICE */ function homeService() {
            initAccordion(".home-service-listing");
            const widthCursor = $(".cursor-wrap .cursor-border").outerWidth();
            const heightCursor = $(".cursor-wrap .cursor-border").outerHeight();
            $(".home-service-item").hover(function() {
                let width = $(this).find(".home-service-item-toggle svg").outerWidth() + 4;
                let height = $(this).find(".home-service-item-toggle svg").outerHeight() + 4;
                $(".cursor-wrap .cursor-border").css("width", width + "px");
                $(".cursor-wrap .cursor-border").css("height", height + "px");
                $(".cursor-wrap .cursor-dot").hide();
            }, function() {
                $(".cursor-wrap .cursor-dot").show();
                $(".cursor-wrap .cursor-border").css("width", widthCursor + "px");
                $(".cursor-wrap .cursor-border").css("height", heightCursor + "px");
            });
            function homeServicePreamble() {
                const WrapHeightRatio = parseInt(parseFloat($(".home-service-preamble").css("height")) / $(window).height());
                let tlImg = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".home-service-preamble",
                        start: `top+=${(0, _index.parseRem)(190)} top`,
                        end: `top+=${$(window).width()} top`,
                        scrub: 1
                    }
                });
                tlImg.to(".home-service-preamble-bg", {
                    autoAlpha: 1,
                    duration: 1,
                    ease: "linear"
                });
                let tlItem = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".home-service-preamble",
                        start: `top+=${$(window).width() * 0.5} top`,
                        end: `bottom bottom`,
                        scrub: 1
                    }
                });
                $(".home-service-preamble-inner-item").each((idx, el)=>{
                    if (idx === 0) tlItem.fromTo(el, {
                        opacity: 0
                    }, {
                        opacity: 1,
                        duration: 1,
                        ease: "none"
                    }, 0).fromTo(el, {
                        opacity: 1
                    }, {
                        opacity: 0,
                        duration: 1,
                        ease: "none"
                    }, `>=.5`);
                    else if (idx < $(".home-service-preamble-inner-item").length - 1) tlItem.fromTo(el, {
                        opacity: 0
                    }, {
                        opacity: 1,
                        duration: 1,
                        ease: "none"
                    }, `>=0`).fromTo(el, {
                        opacity: 1
                    }, {
                        opacity: 0,
                        duration: 1,
                        ease: "none"
                    }, `>=.5`);
                    else tlItem.fromTo(el, {
                        opacity: 0
                    }, {
                        opacity: 1,
                        duration: 1,
                        ease: "none"
                    }, `>=0`);
                    gsap.set(el, {
                        opacity: 0
                    });
                });
            }
            function homeServiceMain() {
                $(".home-service-item").each((idx, el)=>{
                    let itemTitleTxt = new (0, _splitText.SplitText)($(el).find(".home-service-item-title"), (0, _index.typeOpts).chars);
                    let itemToggle = $(el).find(".home-service-item-toggle");
                    let tlItem = gsap.timeline({
                        scrollTrigger: {
                            trigger: el,
                            start: "top top+=80%"
                        },
                        onComplete: ()=>{
                            itemTitleTxt.revert();
                        }
                    });
                    tlItem.from($(el).find(".line"), {
                        scaleX: 0,
                        transformOrigin: "left",
                        duration: 0.6,
                        ease: "power2.out"
                    }, 0).from(itemTitleTxt.chars, {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: 0.03,
                        duration: 0.6,
                        ease: "power2.out"
                    }, 0).from(itemToggle, {
                        y: 60,
                        autoAlpha: 0,
                        duration: 0.8,
                        ease: "power2.out"
                    }, 0);
                });
                $(".home-service-thumb-item").each((idx, el)=>{
                // let clone = $(el).find("img");
                // for (let i = 1; i < 2; i++) {
                //   let cloner = clone.clone();
                //   cloner.addClass("cloner");
                //   $(el).append(cloner);
                // }
                });
                if ($(window).width() > 991) {
                    $(".home-service-item").on("mouseenter", function(e) {
                        let idx = Number($(this).attr("data-thumb-image")) - 1;
                        if ($(".home-service-thumb").find(".home-service-thumb-item").eq(idx).hasClass("active")) return;
                        $(".home-service-thumb").find(".home-service-thumb-item").eq(idx).addClass("active");
                    });
                    $(".home-service-item").on("mouseleave", function(e) {
                        let idx = Number($(this).attr("data-thumb-image")) - 1;
                        $(".home-service-thumb").find(".home-service-thumb-item").eq(idx).removeClass("active");
                    });
                    function initMouseMove() {
                        const target = $(".home-service-thumb");
                        if (target.hasClass("active")) {
                            let tarCurrX = (0, _index.xGetter)(target.get(0));
                            let tarCurrY = (0, _index.yGetter)(target.get(0));
                            let tarCurrRot = (0, _index.rotZGetter)(target.get(0));
                            let tarX = -target.outerWidth() / 4 + ((0, _index.pointerCurr)().x - $(".home-service-listing").get(0).getBoundingClientRect().left) / $(".home-service-listing").outerWidth() * ($(".home-service-listing").outerWidth() / 3 - target.outerWidth() / 2);
                            let tarY = -target.outerHeight() / 4 + ((0, _index.pointerCurr)().y - $(".home-service-listing").get(0).getBoundingClientRect().top) / $(".home-service-listing").outerHeight() * ($(".home-service-listing").outerHeight() - target.outerHeight() / 2);
                            (0, _index.xSetter)(target.get(0))((0, _index.lerp)(tarCurrX, tarX, 0.05));
                            (0, _index.ySetter)(target.get(0))((0, _index.lerp)(tarCurrY, tarY, 0.05));
                            (0, _index.rotZSetter)(target.get(0))((0, _index.lerp)(tarCurrRot, Math.min(Math.max((tarX - tarCurrX) / 40, -7), 7), 0.1));
                        }
                        requestAnimationFrame(initMouseMove);
                    }
                    requestAnimationFrame(initMouseMove);
                }
            }
            ScrollTrigger.create({
                trigger: ".home-service",
                start: "top bottom",
                end: "bottom top",
                toggleClass: {
                    targets: ".home-service-thumb",
                    className: "active"
                }
            });
            ScrollTrigger.create({
                trigger: ".home-service",
                start: "top bottom",
                once: true,
                onEnter: ()=>{
                    homeServicePreamble();
                    requestAnimationFrame(()=>{
                        homeServiceMain();
                    });
                }
            });
        }
        homeService();
        /** (💡)  - PROCESS */ function homeProcess() {
            ScrollTrigger.create({
                trigger: ".home-process",
                start: "top bottom",
                once: true,
                onEnter: ()=>{
                    let titleTxt = new (0, _splitText.SplitText)(".home-process-title", (0, _index.typeOpts).chars);
                    let descTxt = new (0, _splitText.SplitText)(".home-process-desc", (0, _index.typeOpts).words);
                    let tlSplitHead = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".home-process",
                            start: "top top+=80%",
                            // endTrigger: '.home-skill-title',
                            end: "bottom top+=40%"
                        },
                        onComplete: ()=>{
                            titleTxt.revert();
                            descTxt.revert();
                        }
                    });
                    tlSplitHead.from(titleTxt.chars, {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: 0.035,
                        duration: 0.8,
                        ease: "power2.out"
                    }, 0);
                    if ($(window).width() > 767) {
                        tlSplitHead.from(".home-process-btn", {
                            yPercent: 50,
                            autoAlpha: 0,
                            duration: 0.8,
                            ease: "power2.out"
                        }, "<=.8");
                        tlSplitHead.from(descTxt.words, {
                            yPercent: 60,
                            autoAlpha: 0,
                            stagger: 0.025,
                            duration: 0.8,
                            ease: "power2.out"
                        }, "<=.2");
                    }
                    if ($(window).width() <= 767) {
                        tlSplitHead.from(descTxt.words, {
                            yPercent: 60,
                            autoAlpha: 0,
                            stagger: 0.025,
                            duration: 0.8,
                            ease: "power2.out"
                        }, "<=.5");
                        gsap.from(".home-process-btn", {
                            scrollTrigger: {
                                trigger: ".home-process-btn",
                                start: "top top+=80%"
                            },
                            yPercent: 50,
                            autoAlpha: 0,
                            duration: 0.8,
                            ease: "power2.out"
                        });
                    }
                    $(".home-process-step").each((idx, el)=>{
                        let clone = $(el).find(".img");
                        for(let i = 1; i <= 5; i++){
                            let cloner = clone.clone();
                            cloner.addClass("cloner");
                            $(el).find(".home-process-step-img").append(cloner);
                        }
                        let tl = gsap.timeline({
                            scrollTrigger: {
                                trigger: el,
                                start: "top top+=60%",
                                end: "bottom top+=70%",
                                scrub: 0.3
                            }
                        });
                        if (idx % 2 == 0) tl.from($(el).find(".home-process-step-background"), {
                            scale: 0,
                            borderRadius: "8rem",
                            ease: "sine.out",
                            duration: 4
                        }, 0).from($(el).find(".home-process-step-img"), {
                            autoAlpha: 0,
                            scale: 0.8,
                            yPercent: 20,
                            ease: "sine.inOut",
                            duration: 1
                        }, 2).from($(el).find(".home-process-step-label"), {
                            autoAlpha: 0,
                            ease: "sine.in",
                            duration: 1
                        }, "<=.2").from($(el).find(".home-process-step-title"), {
                            autoAlpha: 0,
                            ease: "sine.in",
                            duration: 1
                        }, "<=.4").from($(el).find(".home-process-step-desc"), {
                            autoAlpha: 0,
                            ease: "sine.in",
                            duration: 1
                        }, "<=.4");
                        else tl.from($(el).find(".home-process-step-background"), {
                            scale: 0,
                            borderRadius: "8rem",
                            ease: "sine.out",
                            duration: 4
                        }, 0).from($(el).find(".home-process-step-img"), {
                            autoAlpha: 0,
                            scale: 0.8,
                            yPercent: 20,
                            ease: "sine.inOut",
                            duration: 1
                        }, 2).from($(el).find(".home-process-step-label"), {
                            autoAlpha: 0,
                            ease: "sine.in",
                            duration: 1
                        }, "<=1.2").from($(el).find(".home-process-step-title"), {
                            autoAlpha: 0,
                            ease: "sine.in",
                            duration: 1
                        }, "<=.2").from($(el).find(".home-process-step-desc"), {
                            autoAlpha: 0,
                            ease: "sine.in",
                            duration: 1
                        }, "<=.2");
                    });
                }
            });
        }
        // homeProcess()
        /** (💡)  - PORTFOLIO */ function homePortfolio() {
            function scrollAnimationGrid() {
                const gridItems = $(".home-portfolio-project-item");
                gridItems.each((idx, item)=>{
                    const yPercentRandomVal = gsap.utils.random(0, 60);
                    let tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: item,
                            start: "top bottom",
                            end: "top top-=25%",
                            scrub: gsap.utils.random(0.3, 1.4)
                        }
                    });
                    requestAnimationFrame(()=>{
                        tl.set(item, {
                            transformOrigin: `50% 200%`
                        }).fromTo(item, {
                            scale: 1,
                            yPercent: yPercentRandomVal
                        }, {
                            ease: "none",
                            scale: 0.5,
                            yPercent: 0,
                            borderRadius: "50%"
                        });
                    });
                });
            }
            //scrollAnimationGrid();
            function changeTxtScrollAnim() {
                $(".home-portfolio-content-title .h0").each((idx, el)=>{
                    let tlChangeTxtScrollAnim = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".home-portfolio-project",
                            start: `${(idx + 0) * $(".home-portfolio-project").height() / $(".home-portfolio-content-title .h0").length} top`,
                            end: `${(idx + 1) * $(".home-portfolio-project").height() / $(".home-portfolio-content-title .h0").length} top`,
                            onUpdate: ()=>{
                                $(".home-portfolio-content-title .h0").removeClass("active");
                                $(el).addClass("active");
                            }
                        }
                    });
                });
            }
            //changeTxtScrollAnim()
            function parallaxTitle() {
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".home-portfolio-content",
                        start: "top+=55% top+=50%",
                        end: "top+=55% top+=15%",
                        markers: true,
                        scrub: 1.1
                    }
                });
                tl.to(".home-portfolio-content-intro", {
                    y: 150,
                    ease: "linear",
                    duration: 1
                });
            }
            // parallaxTitle();
            function hoverProject() {
                if ($(window).width() <= 991) changeProjHtml();
                if ($(window).width() > 991) $('.home-project-item').each((idx, el)=>{
                    let link = $(el).attr('href');
                    if (!link.includes('bear.plus')) $(el).find('.home-project-item-view p').text('Visit Website');
                });
                const line = document.createElement("div");
                $(line).addClass("line");
                $(".home-project-item:last-child").append(line);
                const target = $(".home-project-thumb");
                ScrollTrigger.create({
                    trigger: ".home-project",
                    start: "top bottom",
                    end: "bottom top",
                    toggleClass: {
                        targets: target,
                        className: "active"
                    }
                });
                function projectClippath(index, action) {
                    let t = index / $(".home-project-wrap-bot .home-project-item").length * 100;
                    let b = (index + 1) / $(".home-project-wrap-bot .home-project-item").length * 100;
                    gsap.set(".home-project-wrap-top", {
                        clipPath: `polygon(0% ${t}%, 100% ${t}%, 100% ${b}%, 0% ${b}%)`
                    });
                }
                const targetMove = $(".home-project-wrap-top");
                gsap.set(targetMove, {
                    clipPath: `polygon(0 0, 100% 0, 100% 0, 0 0)`
                });
                if ($(window).width() > 991) {
                    $(".home-project-item").on("pointerleave", function(e) {
                        $(".home-project-thumb").find(`[data-thumb-name]`).removeClass("active");
                    });
                    $(".home-project-item").on("pointerenter", function(e) {
                        let nameSpace = $(this).find("[data-project-name]").attr("data-project-name");
                        $(".home-project-thumb").find(`[data-thumb-name]`).removeClass("active");
                        $(".home-project-thumb").find(`[data-thumb-name="${nameSpace}"]`).addClass("active");
                    });
                    $(".home-project-wrap-bot .home-project-item").on("pointerenter", function(e) {
                        let index = $(this).index();
                        projectClippath(index);
                    });
                    $(".home-project-wrap-bot .home-project-item").on("pointerleave", function(e) {
                        if (!$(".home-project-wrap-bot:hover").length && !$(".home-project-wrap-top:hover").length) {
                            if ($(this).is(":first-child")) {
                                let index = -1;
                                let t = index / $(".home-project-wrap-bot .home-project-item").length * 100;
                                let b = (index + 1) / $(".home-project-wrap-bot .home-project-item").length * 100;
                                gsap.set(".home-project-wrap-top", {
                                    clipPath: `polygon(0% ${t}%, 100% ${t}%, 100% ${b}%, 0% ${b}%)`
                                });
                            }
                            if ($(this).is(":last-child")) {
                                let index = $(".home-project-wrap-bot .home-project-item").length;
                                let t = index / $(".home-project-wrap-bot .home-project-item").length * 100;
                                let b = (index + 1) / $(".home-project-wrap-bot .home-project-item").length * 100;
                                gsap.set(".home-project-wrap-top", {
                                    clipPath: `polygon(0% ${t}%, 100% ${t}%, 100% ${b}%, 0% ${b}%)`
                                });
                            }
                        }
                    });
                    initMouseMove();
                } else {
                    $(".home-project-wrap-bot .home-project-item").each((idx, el)=>{
                        ScrollTrigger.create({
                            trigger: el,
                            start: "top center-=5%",
                            end: "bottom center-=5%",
                            // markers: true,
                            onLeave: ()=>{
                                if (idx == $(".home-project-wrap-bot .home-project-item").length - 1) {
                                    $(".home-project-thumb").find(`[data-thumb-name]`).removeClass("active");
                                    let index = $(".home-project-wrap-bot .home-project-item").length;
                                    let t = index / $(".home-project-wrap-bot .home-project-item").length * 100;
                                    let b = (index + 1) / $(".home-project-wrap-bot .home-project-item").length * 100;
                                    gsap.set(".home-project-wrap-top", {
                                        clipPath: `polygon(0% ${t}%, 100% ${t}%, 100% ${b}%, 0% ${b}%)`
                                    });
                                }
                            },
                            onLeaveBack: ()=>{
                                if (idx == 0) {
                                    $(".home-project-thumb").find(`[data-thumb-name]`).removeClass("active");
                                    let index = -1;
                                    let t = index / $(".home-project-wrap-bot .home-project-item").length * 100;
                                    let b = (index + 1) / $(".home-project-wrap-bot .home-project-item").length * 100;
                                    gsap.set(".home-project-wrap-top", {
                                        clipPath: `polygon(0% ${t}%, 100% ${t}%, 100% ${b}%, 0% ${b}%)`
                                    });
                                }
                            },
                            onUpdate: ()=>{
                                let nameSpace = $(el).find("[data-project-name]").attr("data-project-name");
                                $(".home-project-thumb").find(`[data-thumb-name]`).removeClass("active");
                                $(".home-project-thumb").find(`[data-thumb-name="${nameSpace}"]`).addClass("active");
                                let index = $(el).index();
                                projectClippath(index);
                                initClickThumb(index);
                            }
                        });
                    });
                    $(".home-project-wrap-bot .home-project-item").on("click", function(e) {
                        let nameSpace = $(this).find("[data-project-name]").attr("data-project-name");
                        $(".home-project-thumb").find(`[data-thumb-name]`).removeClass("active");
                        $(".home-project-thumb").find(`[data-thumb-name="${nameSpace}"]`).addClass("active");
                        let index = $(this).index();
                        projectClippath(index);
                        initClickThumb(index);
                    });
                }
                function initMouseMove() {
                    let offsetL = parseFloat(target.css("left"));
                    if (target.hasClass("active")) {
                        let tarCurrX = (0, _index.xGetter)(target.get(0));
                        let tarCurrY = (0, _index.yGetter)(target.get(0));
                        let tarCurrRot = (0, _index.rotZGetter)(target.get(0));
                        let tarX = (0, _index.pointerCurr)().x / $(".home-project").outerWidth() * ($(".home-project-item-view").get(0).getBoundingClientRect().left - offsetL - target.width());
                        let tarY = -target.height() / 4 + ((0, _index.pointerCurr)().y - $(".home-project").get(0).getBoundingClientRect().top) / $(".home-project").height() * ($(".home-project").height() - target.height() / 2);
                        (0, _index.xSetter)(target.get(0))((0, _index.lerp)(tarCurrX, tarX, 0.05));
                        (0, _index.ySetter)(target.get(0))((0, _index.lerp)(tarCurrY, tarY, 0.05));
                        (0, _index.rotZSetter)(target.get(0))((0, _index.lerp)(tarCurrRot, Math.min(Math.max((tarX - tarCurrX) / 100, -4), 4), 0.08));
                    }
                    requestAnimationFrame(initMouseMove);
                }
                function initClickThumb(idx) {
                    gsap.to(target, {
                        y: (0, _viewport.cvUnit)((0, _viewport.viewportBreak)({
                            tablet: 80,
                            mobile: 100
                        }), "rem") + ($(".home-project-item").eq(0).outerHeight() - target.outerHeight()) / 2 + idx * $(".home-project-item").eq(0).outerHeight(),
                        overwrite: true
                    });
                }
                function changeProjHtml() {
                    $(".home-project-item").each((idx, el)=>{
                        let targetItem = $(el);
                        let linkItem = $(el).find(".home-project-item-view");
                        let changeLink = $("<a>", {
                            html: linkItem.html(),
                            href: targetItem.attr("href"),
                            target: "_blank",
                            class: linkItem.attr("class")
                        });
                        linkItem.replaceWith(changeLink);
                        let changeTarget = $("<div>", {
                            html: targetItem.html(),
                            class: targetItem.attr("class")
                        });
                        targetItem.replaceWith(changeTarget);
                    });
                }
            }
            hoverProject();
            function projectCurtain() {
                let amount = 11;
                let offset = $(".home-curtain").height() / (amount - 1);
                const clone = $(".home-curtain-inner").eq(0);
                for(let i = 1; i < amount; i++){
                    let cloner = clone.clone();
                    $(".home-curtain").append(cloner);
                }
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".home-curtain",
                        start: `top-=${$(window).width > 991 ? "-40%" : $(window).height()} bottom`,
                        end: "top top-=70%",
                        scrub: true
                    },
                    defaults: {
                        ease: "none"
                    }
                });
                tl.to(".home-curtain-inner", {
                    scaleY: 1,
                    stagger: -0.1,
                    duration: 1,
                    y: -offset
                }, 0);
            }
            projectCurtain();
        }
        homePortfolio();
        /** (💡)  - TESTIMONIAL */ function homeTesti() {
            if ($(window).width() > 767) {
                $(".home-testi").css("height", +$(window).height() + $(".home-testi-content-item").eq(0).height() * 1.5 * $(".home-testi-content-item").length + "px");
                let tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".home-testi",
                        start: `top top`,
                        end: "bottom bottom",
                        scrub: 0.1,
                        onUpdate: (timeline)=>{
                            gsap.set(".home-testi-content-progress-inner", {
                                y: timeline.progress * (0, _viewport.cvUnit)(180, "rem")
                            });
                        }
                    }
                });
                tl.fromTo(".home-testi-text-wrap", {
                    y: (0, _viewport.cvUnit)(-100, "rem")
                }, {
                    y: (0, _viewport.cvUnit)(-90, "rem"),
                    ease: "none"
                });
                let tlScrub = gsap.timeline({
                    scrollTrigger: {
                        trigger: ".home-testi",
                        start: `top+=${$(window).height()} bottom`,
                        end: `bottom-=${$(window).height()} top`,
                        scrub: 0.2,
                        snap: {
                            // To update exact position and check directional
                            snapTo (value) {
                                const dataLength = $(".home-testi-content-item").length;
                                if (value > 0 && value <= 0.1) return 0;
                                else if (value > 0.1 && value <= 0.433) return 0.33;
                                else if (value > 0.433 && value <= 0.766) return 0.66;
                                else if (value > 0.766 && value <= 1) return 1;
                                else return value;
                            },
                            duration: {
                                min: 0.15,
                                max: 1
                            },
                            delay: 0.01
                        }
                    }
                });
                let timeDelay = 0;
                let timeAnim = 1;
                let zUnit = $(window).width() > 991 ? 600 : 1200;
                let yUnit = $(window).width() > 991 ? 90 : 100;
                const setUnit = (number, brightness)=>{
                    return `z: ${(0, _viewport.cvUnit)(-zUnit * number, "rem")}, y: ${(0, _viewport.cvUnit)(-yUnit * number, "rem")}, filter: "brightness(${brightness})"`;
                };
                $(".home-testi-content-item").each((idx, el)=>{
                    // if (idx == 0) {
                    //     tlScrub
                    //         .fromTo($(el), { z: cvUnit(zUnit * 2, 'rem'), yPercent: 75, filter: "brightness(1)" }, { z: 0, yPercent: 0, filter: "brightness(1)", ease: 'power1.out', duration: timeAnim * 2 }, 0)
                    // }
                    if (idx > 0 && idx < $(".home-testi-content-item").length) {
                        tlScrub.fromTo($(el), {
                            z: (0, _viewport.cvUnit)(zUnit, "rem"),
                            yPercent: 200,
                            filter: "brightness(1)"
                        }, {
                            z: 0,
                            yPercent: 0,
                            filter: "brightness(1)",
                            ease: "power3.out",
                            duration: timeAnim
                        }, `>=${timeDelay}`).fromTo($(el).prev(), {
                            z: 0,
                            y: 0,
                            filter: "brightness(1)"
                        }, {
                            z: (0, _viewport.cvUnit)(-zUnit, "rem"),
                            y: (0, _viewport.cvUnit)(-yUnit, "rem"),
                            filter: "brightness(.67)",
                            ease: "power2.out",
                            duration: timeAnim
                        }, "<=0");
                        if (idx > 1) tlScrub.fromTo($(el).prev().prev(), {
                            z: (0, _viewport.cvUnit)(-zUnit, "rem"),
                            y: (0, _viewport.cvUnit)(-yUnit, "rem"),
                            filter: "brightness(.67)"
                        }, {
                            z: (0, _viewport.cvUnit)(-zUnit * 2, "rem"),
                            y: (0, _viewport.cvUnit)(-yUnit * 2, "rem"),
                            filter: "brightness(.33)",
                            ease: "power2.out",
                            duration: timeAnim
                        }, "<=0");
                        if (idx > 2) tlScrub.fromTo($(el).prev().prev().prev(), {
                            z: (0, _viewport.cvUnit)(-zUnit * 2, "rem"),
                            y: (0, _viewport.cvUnit)(-yUnit * 2, "rem"),
                            filter: "brightness(.33)"
                        }, {
                            z: (0, _viewport.cvUnit)(-zUnit * 3, "rem"),
                            y: (0, _viewport.cvUnit)(-yUnit * 3, "rem"),
                            filter: "brightness(0)",
                            ease: "power2.out",
                            duration: timeAnim
                        }, "<=0");
                    }
                // if (idx == ($('.home-testi-content-item').length - 1)) {
                //     tlScrub
                //         .fromTo($(el), { z: 0, y: 0, filter: "brightness(1)" }, { z: cvUnit(-zUnit, 'rem'), y: cvUnit(-yUnit, 'rem'), filter: "brightness(.67)", ease: 'power3.out', duration: timeAnim }, `>=${timeDelay}`)
                //         .fromTo($(el).prev(), { z: cvUnit(-zUnit, 'rem'), y: cvUnit(-yUnit, 'rem'), filter: "brightness(.67)" }, { z: cvUnit(-zUnit * 2, 'rem'), y: cvUnit(-yUnit * 2, 'rem'), filter: "brightness(.33)", ease: 'power3.out', duration: timeAnim }, "<=0")
                //         .fromTo($(el).prev().prev(), { z: cvUnit(-zUnit * 2, 'rem'), y: cvUnit(-yUnit * 2, 'rem'), filter: "brightness(.33)" }, { z: cvUnit(-zUnit * 3, 'rem'), y: cvUnit(-yUnit * 3, 'rem'), filter: "brightness(0)", ease: 'power3.out', duration: timeAnim }, "<=0")
                // }
                });
                gsap.set(".home-testi-content-item", {
                    z: 0,
                    y: 0,
                    filter: "brightness(1)"
                });
            } else {
                let parent = $(".home-testi-content");
                parent.find('[data-swiper="swiper"]').addClass("swiper");
                parent.find('[data-swiper="swiper-wrapper"]').addClass("swiper-wrapper");
                parent.find('[data-swiper="swiper-slide"]').addClass("swiper-slide");
                new Swiper(".home-testi-content-wrap", {
                    spaceBetween: (0, _viewport.cvUnit)(20, "rem"),
                    slidesPerView: 1,
                    scrollbar: {
                        el: ".home-testi-content-progress"
                    }
                });
            }
        }
        homeTesti();
        /** (💡)  - PRICING */ function homePricing() {
            ScrollTrigger.create({
                trigger: ".home-pricing",
                start: "top bottom",
                once: true,
                onEnter: ()=>{
                    let titleTxt = new (0, _splitText.SplitText)(".home-pricing-text-title", (0, _index.typeOpts).words);
                    let subArray = [];
                    let tlSplitHead = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".home-pricing",
                            start: "top top+=40%"
                        },
                        onComplete: ()=>{
                            titleTxt.revert();
                            $(subArray).each((idx, el)=>el.revert());
                        }
                    });
                    tlSplitHead.from(titleTxt.words, {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: 0.02,
                        duration: 0.6,
                        ease: "power2.out"
                    }, 0.3).from(".home-pricing-plan-switch", {
                        yPercent: 60,
                        autoAlpha: 0,
                        duration: 0.8,
                        ease: "power2.out",
                        clearProps: "all"
                    }, "<=.2");
                    $(".home-pricing-text-sub-item").each((idx, el)=>{
                        let subTxt = new (0, _splitText.SplitText)($(el).find(".home-pricing-text-sub-item-txt"), (0, _index.typeOpts).words);
                        tlSplitHead.from($(el).find(".dot"), {
                            yPercent: 60,
                            autoAlpha: 0,
                            duration: 0.4,
                            ease: "power2.out",
                            clearProps: "all"
                        }, 0.3 + idx * 0.1).from(subTxt.words, {
                            yPercent: 60,
                            autoAlpha: 0,
                            stagger: 0.02,
                            duration: 0.6,
                            ease: "power2.out"
                        }, 0.35 + idx * 0.1);
                        subArray.push(subTxt);
                    });
                    let tlPricing = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".home-pricing--wrap",
                            start: "top top+=60%"
                        }
                    });
                    tlPricing.from(".home-pricing-plan-item.popular", {
                        y: (0, _viewport.cvUnit)(60, "rem"),
                        autoAlpha: 0,
                        duration: 0.8,
                        ease: "power2.out",
                        clearProps: "all"
                    }, "<=1").from(".home-pricing-plan-item:not(.popular)", {
                        y: (0, _viewport.cvUnit)(60, "rem"),
                        autoAlpha: 0,
                        duration: 0.8,
                        ease: "power2.out",
                        clearProps: "all"
                    }, "<=.2");
                    let ctaHeadingTxt = new (0, _splitText.SplitText)(".home-pricing-plan-cta-heading", (0, _index.typeOpts).lines);
                    let tlCTAHead = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".home-pricing-plan-cta",
                            start: "top top+=80%"
                        },
                        onComplete: ()=>{
                            ctaHeadingTxt.revert();
                        }
                    });
                    tlCTAHead.from(ctaHeadingTxt.lines, {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: 0.3,
                        duration: 0.6,
                        ease: "power2.out"
                    }, 0).from(".home-pricing-plan-cta .btn-border", {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: 0.3,
                        duration: 0.6,
                        ease: "power2.out",
                        clearProps: "all"
                    }, "<=.3");
                }
            });
            function switchPlan() {
                const DOM = {
                    btnPlan: $(".home-pricing-plan-switch-wrap .home-pricing-plan-switch-btn"),
                    btnOverlay: $(".home-pricing-plan-switch-overlay"),
                    periodic: $(".home-pricing-plan-item-price-periodic"),
                    price: $(".home-pricing-plan-item-price-txt"),
                    btnPurchase: $(".home-pricing-plan-item-btn > .btn-purchase"),
                    priceOff: $(".home-pricing-plan-item-off")
                };
                const data = [
                    {
                        name: "quarter-time",
                        price_id: {
                            monthly: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-2FU91487WY5914922NA6XOZI",
                            quarterly: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-3UN99138DF6683533NA6XU7Q"
                        }
                    },
                    {
                        name: "part-time",
                        price_id: {
                            monthly: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-4K1796600R122332SNA6XVYY",
                            quarterly: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-9225614061780104SNA6XWEQ"
                        }
                    },
                    {
                        name: "full-time",
                        price_id: {
                            monthly: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-2FS05115TE451125NNA6XYFY",
                            quarterly: "https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-3M265801A9612925HNA6XYQA"
                        }
                    }
                ];
                function activePlan(index) {
                    gsap.to(DOM.btnOverlay, {
                        x: index * DOM.btnOverlay.width()
                    });
                    let tl = gsap.timeline();
                    tl.to(DOM.btnOverlay.eq(1), {
                        autoAlpha: 0.5
                    }).to(DOM.btnOverlay.eq(0), {
                        autoAlpha: 1
                    }, 0.2).to(DOM.btnOverlay.eq(1), {
                        autoAlpha: 1
                    }, 0.5).to(DOM.btnOverlay.eq(0), {
                        autoAlpha: 0
                    }, 0.5);
                    DOM.price.each((i, item)=>{
                        let text = $(item).find("h3");
                        text.removeClass("active");
                        text.eq(index).addClass("active");
                    });
                    DOM.periodic.each((i, item)=>{
                        let text = $(item).find("p");
                        text.removeClass("active");
                        text.eq(index).addClass("active");
                    });
                    if (index > 0) // DOM.priceOff.removeClass('active')
                    DOM.priceOff.slideUp("fast");
                    else // DOM.priceOff.addClass('active')
                    DOM.priceOff.slideDown("fast");
                    let currPlan = DOM.btnPlan.eq(index).text();
                    let subsType = index === 0 ? "quarterly" : "monthly";
                    DOM.btnPurchase.each((i, item)=>{
                        if ($(item).attr("data-purchase-method") === "subscription") {
                            let priceId = $(item).attr("data-price");
                            $(item).attr("data-subtype", subsType);
                            let dataSrc = data.filter((el)=>el.name === priceId);
                            $(item).attr("href", dataSrc[0].price_id[subsType]);
                            $(item).attr("data-cycle", subsType);
                        } else return;
                    });
                }
                activePlan(0);
                DOM.btnPlan.on("click", function(e) {
                    let index = $(this).index();
                    e.preventDefault();
                    activePlan(index);
                });
            }
            switchPlan();
            function paymentViaContact() {
                $('.btn-purchase, [data-price][data-popup-contact="open"]').on('click', function(e) {
                    e.preventDefault();
                    let planName = $(this).attr('data-price');
                    let planType = $(this).attr('data-cycle') || $(this).attr('data-subtype');
                    console.log(planName, planType);
                    // Handle Plan selection
                    if (planName) {
                        const submenuLabel = $(`[data-field-name="plan"] .accordion__submenu-item[data-plan-name="${planName}"]`).find(".accordion__submenu-label").text();
                        if (submenuLabel) {
                            $('#plan').val(submenuLabel);
                            $('[data-field-name="plan"] .accordion__submenu-item').removeClass('active');
                            $(`[data-field-name="plan"] .accordion__submenu-item[data-plan-name="${planName}"]`).addClass('active');
                            $('[data-field-name="plan"] .popup-contact-inner-content-sidebar-form-accordion-label').text(submenuLabel);
                        }
                    }
                    // Handle Cycle selection
                    if (planType && planType !== 'customized') {
                        const submenuLabelCycle = $(`[data-field-name="cycle"] .accordion__submenu-item[data-cycle-name="${planType}"]`).find(".accordion__submenu-label").text();
                        if (submenuLabelCycle) {
                            $('#cycle').val(submenuLabelCycle);
                            $('[data-field-name="cycle"] .accordion__submenu-item').removeClass('active');
                            $(`[data-field-name="cycle"] .accordion__submenu-item[data-cycle-name="${planType}"]`).addClass('active');
                            $('[data-field-name="cycle"] .popup-contact-inner-content-sidebar-form-accordion-label').text(submenuLabelCycle);
                        }
                    } else if (planType === 'customized') {
                        // For customized cycle, set to "Unselected"
                        $('#cycle').val('');
                        $('[data-field-name="cycle"] .accordion__submenu-item').removeClass('active');
                        $('[data-field-name="cycle"] .popup-contact-inner-content-sidebar-form-accordion-label').text('Unselected');
                    }
                });
            }
            paymentViaContact();
        }
        requestAnimationFrame(()=>{
            homePricing();
        });
        /** (💡)  - INDUSTRIES */ function homeExplore() {
            ScrollTrigger.create({
                trigger: ".home-explore",
                start: "top bottom",
                once: true,
                onEnter: ()=>{
                    let headTxt = new (0, _splitText.SplitText)(".home-explore-heading h3", (0, _index.typeOpts).chars);
                    let tlSplitHead = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".home-explore-heading",
                            start: "top top+=90%",
                            end: "bottom top+=40%",
                            scrub: 0.1
                        }
                    });
                    tlSplitHead.from(headTxt.chars, {
                        color: "#121212",
                        stagger: 0.05,
                        duration: 0.6,
                        ease: "power1.out"
                    }, 0);
                    let titleTxt = new (0, _splitText.SplitText)(".home-explore-industries-title", (0, _index.typeOpts).words);
                    let tlSplitTitle = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".home-explore-industries-title",
                            start: "top top+=95%"
                        }
                    });
                    tlSplitTitle.from(titleTxt.words, {
                        yPercent: 60,
                        autoAlpha: 0,
                        stagger: 0.02,
                        duration: 0.6,
                        ease: "power2.out"
                    }, 0);
                    if ($(window).width() > 991) {
                        function parallaxLogo() {
                            let target = $(".home-explore-img img");
                            let tarCurrX = (0, _index.xGetter)(target.get(0));
                            let tarCurrY = (0, _index.yGetter)(target.get(0));
                            let moveX = ((0, _index.pointerCurr)().x / $(window).width() - 0.5) * 2 * (target.width() / 4);
                            let moveY = ((0, _index.pointerCurr)().y / $(window).height() - 0.5) * 2 * (target.height() / 8);
                            (0, _index.xSetter)(target.get(0))((0, _index.lerp)(tarCurrX, moveX, 0.01));
                            (0, _index.ySetter)(target.get(0))((0, _index.lerp)(tarCurrY, moveY, 0.01));
                            requestAnimationFrame(parallaxLogo);
                        }
                        requestAnimationFrame(parallaxLogo);
                    } else gsap.fromTo(".home-explore-img img", {
                        yPercent: (0, _viewport.viewportBreak)({
                            tablet: 20,
                            mobile: 40
                        })
                    }, {
                        scrollTrigger: {
                            trigger: ".home-explore-heading",
                            start: "top bottom",
                            end: "bottom top",
                            scrub: 0.2
                        },
                        yPercent: -50,
                        ease: "none"
                    });
                    const DOM = {
                        radarScan: $(".home-explore-industries-radar-scan"),
                        lineItem: $(".home-explore-industries-radar-wrapper-item-line"),
                        dot: $(".home-explore-industries-radar-wrapper-item-line-dot-wrap")
                    };
                    gsap.set(DOM.radarScan, {
                        rotate: -10
                    });
                    let lifeCycleTime = 8;
                    let tl = gsap.timeline({
                        repeat: -1,
                        defaults: {
                            ease: "none"
                        }
                    });
                    tl.fromTo(DOM.radarScan, {
                        rotate: -10
                    }, {
                        rotate: 260,
                        duration: lifeCycleTime,
                        ease: "none"
                    }, 0);
                    DOM.lineItem.each((idx, el)=>{
                        tl.to($(el).find(DOM.dot), {
                            onStart: ()=>{
                                $(el).find(DOM.dot).addClass("active");
                            }
                        }, `${0.1254480287 * lifeCycleTime + 0.1111111111 * idx * lifeCycleTime}`).to($(el).find(DOM.dot), {
                            onStart: ()=>{
                                $(el).find(DOM.dot).removeClass("active");
                            }
                        }, "<=2");
                    });
                    $(".home-explore-industries-radar-wrapper-item-line-dot-wrap").on("pointerenter", function(e) {
                        $(this).addClass("on-hover");
                    });
                    $(".home-explore-industries-radar-wrapper-item-line-dot-wrap").on("pointerleave", function(e) {
                        $(this).removeClass("on-hover");
                    });
                }
            });
        }
        //homeExplore()
        /** (💡)  - FAQ */ function homeFaq() {
            initAccordion(".home-faq-content-listing");
        }
        homeFaq();
        // popup
        const initPopup = (name)=>{
            let popupWrap = $(`[data-popup-${name}='wrap']`);
            const required = (message)=>({
                    message,
                    required: true
                });
            const regexp = (pattern, message)=>({
                    regexp: pattern,
                    message
                });
            const REGEXP = {
                email: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
            };
            const popupAction = {
                open: ()=>{
                    popupWrap.addClass("active");
                    requestAnimationFrame(()=>$(".header-bar").addClass("force"));
                    (0, _lenis.lenis).stop();
                },
                close: ()=>{
                    console.log('close');
                    if (!popupWrap.hasClass("active")) return;
                    // Hide success overlay if visible
                    $('.popup-contact-success-overlay').fadeOut(200);
                    // Close all accordion submenus (but keep their values)
                    // Target all accordion submenu variations
                    popupWrap.find('.js-accordion-submenu, .popup-contact-inner-content-sidebar-form-accordion-submenu').each(function() {
                        $(this).slideUp('fast');
                    });
                    // Remove is-open class from all accordion items
                    popupWrap.find('.accordion__item').removeClass("is-open");
                    setTimeout(()=>{
                        popupWrap.removeClass("active");
                        $(".header-bar").removeClass("force");
                    }, 100);
                    (0, _lenis.lenis).start();
                }
            };
            $(`[data-popup-${name}]`).on("click", function(e) {
                if ($(this).attr(`data-popup-${name}`) === "open") {
                    e.preventDefault();
                    popupAction.open();
                } else if ($(this).attr(`data-popup-${name}`) === "close") {
                    e.preventDefault();
                    popupAction.close();
                } else return;
            });
            $(window).on("click", (e)=>{
                if (!$(`[data-popup-${name}='open']:hover`).length) {
                    if ($(`[data-popup-${name}="wrap"]`).hasClass("active")) return;
                    popupAction.close();
                }
            });
            $(`[data-popup-${name}="wrap"] .popup-overlay`).on("click", function(e) {
                popupAction.close();
            });
            function accordion() {
                let Accordion = function(el, multiple) {
                    this.el = el || {};
                    this.multiple = multiple || false;
                    // Variables privadas
                    var links = this.el.find(".popup-contact-inner-content-sidebar-form-control");
                    // Evento
                    links.on("click", {
                        el: this.el,
                        multiple: this.multiple
                    }, this.dropdown);
                };
                Accordion.prototype.dropdown = function(e) {
                    var $el = e.data.el, $this = $(this), $next = $this.find('.popup-contact-inner-content-sidebar-form-accordion-submenu');
                    $next.slideToggle();
                    $this.parent().toggleClass("is-open");
                    if (!e.data.multiple) {
                        $el.find(".js-accordion-submenu").not($next).slideUp().parent().removeClass("is-open");
                        $el.find(".js-accordion-submenu").not($next).slideUp();
                    }
                };
                let accordionPlan = new Accordion($("#accordion-plan"), false);
                let accordionCycle = new Accordion($("#accordion-cycle"), false);
                let allAccordions = $('.input-field-group:has(.accordion__item)');
                allAccordions.each(function() {
                    let accordion = $(this);
                    let accordionLabel = $(this).find(".popup-contact-inner-content-sidebar-form-accordion-label");
                    let inputEl = $(this).find('input');
                    let placeholder = $(this).find('input').attr('placeholder');
                    console.log(placeholder);
                    if (inputEl.val()) accordionLabel.html(`${inputEl.val()}`);
                    else accordionLabel.html(placeholder);
                    $(this).find(".accordion__submenu-item").on("click", function(e) {
                        const submenuLabel = $(this).find(".accordion__submenu-label").text();
                        inputEl.val(submenuLabel);
                        $(this).find(".accordion__submenu-item").removeClass('active');
                        $(this).addClass('active');
                        accordionLabel.text(submenuLabel);
                    });
                });
            }
            accordion();
            const mapFormToObject = (form, originFormData)=>{
                /** -NOTE-
         * read it: https://stackoverflow.com/questions/12077859/difference-between-this-and-event-target
         * form: this property will be
         *          [e.target]: when the form have event
         *       or [$(formID).get(0)]: when the form don't have event
         */ let formData = originFormData || new FormData(form);
                const parsedFormData = [
                    ...formData.entries()
                ].reduce((prev, cur)=>{
                    const name = cur[0];
                    const val = cur[1];
                    let dataName;
                    for (let field of form){
                        let fieldDataName = field.dataset.name;
                        let fieldName = field.name;
                        if (name === fieldName) dataName = fieldDataName;
                    }
                    return {
                        ...prev,
                        [name]: {
                            value: val,
                            name: dataName,
                            validType: []
                        }
                    };
                }, {});
                return parsedFormData;
            };
            const mapObjectFormToValidate = (form, obj)=>{
                const parsedFormData = [
                    ...Object.entries(obj)
                ].reduce((prev, cur)=>{
                    const name = cur[0];
                    const val = cur[1];
                    let validArr = val.validType;
                    for (let field of form){
                        let fieldName = field.name;
                        let fieldType = field.type;
                        let fieldRequired = field.required || false;
                        let REGEXP_TYPE = [
                            "email"
                        ];
                        if (name === fieldName) {
                            if (fieldRequired) {
                                let CusMessage = field.getAttribute("mess-required");
                                validArr.unshift(required(CusMessage));
                            }
                            if (REGEXP_TYPE.includes(fieldType)) {
                                let CusMessage = field.getAttribute("mess-regexp");
                                let CusRegexp = field.getAttribute("cus-regexp");
                                validArr.unshift(regexp(CusRegexp || fieldType, CusMessage));
                            }
                        }
                        continue;
                    }
                    return {
                        ...prev,
                        [name]: val
                    };
                }, {});
                return parsedFormData;
            };
            const validateForm = ({ formsObj: forms, rules })=>{
                const errors = {};
                for(let name in rules)for (let rule of rules[name].validType){
                    if (rule.required && forms[name]) {
                        if (!forms[name].value.trim() || forms[name].value.trim() == "false") errors[name] = rule.message || ERROR_MESSAGE.required(forms[name].name);
                    }
                    if (rule.regexp && forms[name]) {
                        let regexp = rule.regexp;
                        if (regexp in REGEXP) regexp = new RegExp(REGEXP[regexp]);
                        else if (!(regexp instanceof RegExp)) regexp = new RegExp();
                        if (!regexp.test(forms[name].value.trim())) errors[name] = rule.message || ERROR_MESSAGE.regexp;
                    }
                }
                return {
                    errors,
                    isValidated: Object.keys(errors).length === 0
                };
            };
            const showError = (message = "Something error")=>{
                alert(message);
            };
            let submitBtn = $('.popup-contact-inner-content-sidebar-form [data-form-btn="submit"]');
            const setLoading = (isLoading)=>{
                console.log(isLoading);
                if (isLoading) {
                    // console.log(textEle)
                    submitBtn.find('.popup-contact-inner-content-sidebar-form-btn-submit').text('Please wait ...');
                    submitBtn.css({
                        'pointer-events': 'none'
                    });
                } else {
                    submitBtn.find('.popup-contact-inner-content-sidebar-form-btn-submit').text('Submit');
                    submitBtn.css({
                        'pointer-events': ''
                    });
                }
            };
            const mapField = (data)=>{
                return Object.keys(data).map((key)=>({
                        name: key,
                        value: data[key] || ''
                    }));
            };
            function sendDataResend(data) {
                $.ajax({
                    url: '/.netlify/functions/contact',
                    method: 'POST',
                    data: JSON.stringify(data),
                    dataType: 'json',
                    contentType: 'application/json',
                    success: function(response) {
                        console.log('Email sent successfully via Resend:', response);
                        // Stop loading state
                        setLoading(false);
                        // Redirect to thank you page after a short delay
                        setTimeout(()=>{
                            window.location.href = '/thank-you';
                        }, 500);
                    },
                    error: function(error) {
                        console.error('Failed to send email via Resend:', error);
                        showError('Failed to send your message. Please try again.');
                        setLoading(false);
                    }
                });
            }
            function showSuccessMessage() {
                // Create success overlay if it doesn't exist
                if (!$('.popup-contact-success-overlay').length) {
                    const successHTML = `
          <div class="popup-contact-success-overlay">
            <div class="popup-contact-success-content">
              <div class="popup-contact-success-icon">
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="40" cy="40" r="40" fill="#10B981"/>
                  <path d="M25 40L35 50L55 30" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <h3 class="popup-contact-success-title">Message Sent Successfully!</h3>
              <p class="popup-contact-success-text">Thank you for contacting us. We'll get back to you shortly.</p>
              <div class="btn-border popup-contact-success-btn-wrapper" data-popup-contact="close" data-cursor="btnstick">
                <button class="btn popup-contact-success-btn" type="button">
                  <div class="btnoverlay"></div>
                  <div class="txt-wrap">
                    <span class="txt txt-16 txt-btn">Close</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        `;
                    $('.popup-contact-inner-content-sidebar').append(successHTML);
                    // Add click handler to close when clicking outside content
                    $('.popup-contact-success-overlay').on('click', function(e) {
                        if ($(e.target).hasClass('popup-contact-success-overlay')) $(this).fadeOut(300);
                    });
                    // Add click handler for the close button to close both overlay and popup
                    $('.popup-contact-success-btn-wrapper, .popup-contact-success-btn').on('click', function(e) {
                        e.stopPropagation();
                        clearTimeout($('.popup-contact-success-overlay').data('autoHideTimeout'));
                        // Close the success overlay first
                        $('.popup-contact-success-overlay').fadeOut(200);
                        // Then trigger the main popup close
                        setTimeout(()=>{
                            // Find and click any close button in the popup
                            const closeBtn = $('[data-popup-contact="wrap"]').find('[data-popup-contact="close"]');
                            if (closeBtn.length) closeBtn.first().click();
                            else {
                                // Fallback: manually trigger close
                                $('[data-popup-contact="wrap"]').removeClass("active");
                                $(".header-bar").removeClass("force");
                                (0, _lenis.lenis).start();
                            }
                        }, 200);
                    });
                }
                // Show the success overlay with flex display
                $('.popup-contact-success-overlay').css('display', 'flex').hide().fadeIn(400);
                // Add haptic feedback for mobile devices
                if ('vibrate' in navigator) navigator.vibrate([
                    100,
                    50,
                    100
                ]); // Two short vibrations
                // Auto-hide after 6 seconds (increased for better UX)
                const autoHideTimeout = setTimeout(()=>{
                    $('.popup-contact-success-overlay').fadeOut(400);
                }, 6000);
                // Store timeout ID for manual close handling
                $('.popup-contact-success-overlay').data('autoHideTimeout', autoHideTimeout);
            }
            function sendDataHubspot(data) {
                let portalId = '46924593';
                let formId = '3d53f0e5-1b84-4da7-a032-ecb348d101ef';
                let url = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`;
                const mappedFields = mapField(data);
                const dataSend = {
                    fields: mappedFields,
                    context: {
                        pageUri: window.location.href,
                        pageName: "Form"
                    }
                };
                console.log(dataSend);
                $.ajax({
                    url: url,
                    method: 'POST',
                    data: JSON.stringify(dataSend),
                    dataType: 'json',
                    headers: {
                        accept: 'application/json',
                        'Access-Control-Allow-Origin': '*'
                    },
                    contentType: 'application/json',
                    success: function(response) {
                        $('.popup-contact-inner-content-sidebar-form').get(0).reset();
                        // if (fileOptions) {
                        //     const { fileEle } = fileOptions;
                        //     fileEle.reset();
                        // }
                        // if (onSuccess) onSuccess();
                        // // alert('Success');
                        setLoading(false);
                        console.log('success');
                    },
                    error: function(error) {
                        if (error.readyState === 4) {
                            const errors = error.responseJSON.errors;
                            const errorArr = errors[0].message.split('.');
                            const errorMess = errorArr[errorArr.length - 1];
                            showError(errorMess);
                        } else showError('Something error');
                        setLoading(false);
                    }
                });
            }
            const submitForm = ({ formsObj, rules })=>{
                let validateInfo = {
                    status: false,
                    resultForm: {}
                };
                const { errors, isValidated } = validateForm({
                    formsObj,
                    rules
                });
                if (isValidated) {
                    validateInfo.status = true;
                    Object.entries(rules).forEach(([key, { value }])=>{
                        validateInfo.resultForm[key.toLowerCase()] = value;
                    });
                    return {
                        validateInfo
                    };
                } else {
                    validateInfo.status = false;
                    return {
                        errors,
                        validateInfo
                    };
                }
            };
            const errorValidation = {
                singleActive: (input, error)=>{
                    let errorEl = $(input).find('.input-field-error');
                    if (error) {
                        $(errorEl).html(error);
                        $(errorEl).slideDown('fast');
                    } else $(errorEl).slideUp('fast', ()=>$(errorEl).html(''));
                },
                active: (form, errors)=>{
                    Array.from(form.querySelectorAll('.input-field-group input')).forEach((node)=>{
                        let errorEl = node.parentElement.querySelector('.input-field-error');
                        if (errors.hasOwnProperty(node.getAttribute('name'))) {
                            errorEl.innerHTML = errors[node.getAttribute('name')];
                            $(errorEl).slideDown('fast');
                        } else $(errorEl).slideUp('fast', ()=>errorEl.innerHTML = '');
                    });
                },
                reset: (form)=>{
                    Array.from(form.querySelectorAll('.input-field-group input')).forEach((node)=>{
                        let errorEl = node.parentElement.querySelector('.input-field-error');
                        $(errorEl).slideUp('fast', ()=>errorEl.innerHTML = '');
                    });
                }
            };
            const validateInput = ({ targetInputObject: input, targetInputRule: rules })=>{
                let errors;
                const isEmpty = (value)=>value == null || typeof value === "string" && value.trim().length === 0;
                for (let rule of rules.validType){
                    if (rule.required) {
                        if (!input.value.trim() || input.value.trim() == "false") errors = rule.message || ERROR_MESSAGE.required(input.name);
                    }
                    if (rule.regexp) {
                        let regexp = rule.regexp;
                        if (regexp in REGEXP) regexp = new RegExp(REGEXP[regexp]);
                        else if (!(regexp instanceof RegExp)) regexp = new RegExp();
                        if (!regexp.test(input.value.trim())) errors = rule.message || ERROR_MESSAGE.regexp;
                    }
                }
                return errors;
            };
            const validateOnInput = ({ targetInputObject, targetInputRule })=>{
                let validateInfo = {
                    status: false,
                    resultForm: {}
                };
                const error = validateInput({
                    targetInputObject,
                    targetInputRule
                });
                return error;
            };
            const formHandler = (formID, options = {})=>{
                const formTarget = $(formID).get(0);
                let formsObj = mapFormToObject(formTarget);
                let rules = mapObjectFormToValidate(formTarget, formsObj);
                const validateThisInput = (e)=>{
                    let targetInputObject = {
                        ...formsObj[$(e.target).attr("name")],
                        value: $(e.target).val()
                    };
                    let targetInputRule = {
                        ...rules[$(e.target).attr("name")]
                    };
                    const error = validateOnInput({
                        targetInputObject,
                        targetInputRule
                    });
                    errorValidation.singleActive($(e.target).closest(".input-field-group"), error);
                };
                $(`${formID} .input-field-group input`).bind("input", (0, _index.debounce)(validateThisInput));
                $(`${formID} [data-form-btn="submit"]`).on("click", function(e) {
                    const { onSuccess, onError } = options;
                    formsObj = mapFormToObject(formTarget);
                    rules = mapObjectFormToValidate(formTarget, formsObj);
                    const { errors, validateInfo } = submitForm({
                        formsObj,
                        rules
                    });
                    if (validateInfo.status) {
                        e.preventDefault();
                        setLoading(true);
                        // Send to both Resend and HubSpot
                        sendDataResend(validateInfo.resultForm);
                        // sendDataHubspot(validateInfo.resultForm)
                        onSuccess?.(validateInfo);
                        // $(this).closest("form").trigger("submit");
                        errorValidation.reset($(formID).get(0));
                    } else {
                        e.preventDefault();
                        onError?.(errors);
                        errorValidation.active($(formID).get(0), errors);
                    }
                    return false;
                });
            };
            formHandler("#contact-form", {});
        };
        initPopup("contact");
    },
    beforeLeave () {
        console.log(`leave ${this.namespace}`);
    }
};
exports.default = home;

},{"../../helper/index":"lOTX9","../../helper/viewport":"e5DfO","../../global/lenis":"2RIXr","../../libs/SplitText":"cLlMb","@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"lOTX9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lerp", ()=>lerp);
parcelHelpers.export(exports, "parseRem", ()=>parseRem);
parcelHelpers.export(exports, "xSetter", ()=>xSetter);
parcelHelpers.export(exports, "ySetter", ()=>ySetter);
parcelHelpers.export(exports, "scaleXSetter", ()=>scaleXSetter);
parcelHelpers.export(exports, "scaleYSetter", ()=>scaleYSetter);
parcelHelpers.export(exports, "rotZSetter", ()=>rotZSetter);
parcelHelpers.export(exports, "opacitySetter", ()=>opacitySetter);
parcelHelpers.export(exports, "xGetter", ()=>xGetter);
parcelHelpers.export(exports, "yGetter", ()=>yGetter);
parcelHelpers.export(exports, "scaleXGetter", ()=>scaleXGetter);
parcelHelpers.export(exports, "scaleYGetter", ()=>scaleYGetter);
parcelHelpers.export(exports, "opacityGetter", ()=>opacityGetter);
parcelHelpers.export(exports, "selector", ()=>selector);
parcelHelpers.export(exports, "rotZGetter", ()=>rotZGetter);
parcelHelpers.export(exports, "typeOpts", ()=>typeOpts);
parcelHelpers.export(exports, "pointerCurr", ()=>pointerCurr);
parcelHelpers.export(exports, "findClosestEdge", ()=>findClosestEdge);
parcelHelpers.export(exports, "closestEdge", ()=>closestEdge);
parcelHelpers.export(exports, "distMetric", ()=>distMetric);
parcelHelpers.export(exports, "FloatingAnimation", ()=>FloatingAnimation);
parcelHelpers.export(exports, "debounce", ()=>debounce);
parcelHelpers.export(exports, "inView", ()=>inView);
var _viewport = require("../helper/viewport");
const lerp = (a, b, t = 0.08)=>{
    return a + (b - a) * t;
};
const parseRem = (input)=>{
    return input / 10 * parseFloat($('html').css('font-size'));
};
const xSetter = (el)=>gsap.quickSetter(el, 'x', `px`);
const ySetter = (el)=>gsap.quickSetter(el, 'y', `px`);
const scaleXSetter = (el)=>gsap.quickSetter(el, 'scaleX');
const scaleYSetter = (el)=>gsap.quickSetter(el, 'scaleY');
const rotZSetter = (el)=>gsap.quickSetter(el, 'rotateZ', `deg`);
const opacitySetter = (el)=>gsap.quickSetter(el, 'opacity', ``);
const xGetter = (el)=>gsap.getProperty(el, 'x');
const yGetter = (el)=>gsap.getProperty(el, 'y');
const scaleXGetter = (el)=>gsap.getProperty(el, 'scaleX');
const scaleYGetter = (el)=>gsap.getProperty(el, 'scaleY');
const rotZGetter = (el)=>gsap.getProperty(el, 'rotateZ');
const opacityGetter = (el)=>gsap.getProperty(el, 'opacity');
const selector = (parent)=>{
    return (child)=>$(parent).find(child);
};
let typeOpts = {
    lines: {
        type: 'lines',
        linesClass: 'g-lines'
    },
    words: {
        type: 'words,lines',
        linesClass: 'g-lines'
    },
    chars: {
        type: 'chars,words,lines',
        linesClass: 'g-lines'
    }
};
let pointer = {
    x: $(window).width() / 2,
    y: $(window).height() / 2
};
$(window).on('pointermove', function(e) {
    pointer.x = e.clientX;
    pointer.y = e.clientY;
    if ($('.cursor-wrap').hasClass('on-hidden') && !(0, _viewport.isTouchDevice)() && $(window).width() > 991) $('.cursor-wrap').removeClass('on-hidden');
});
const pointerCurr = ()=>{
    return pointer;
};
const inView = (el)=>{
    if (0 <= el.getBoundingClientRect().bottom && el.getBoundingClientRect().top <= $(window).height()) return true;
};
function debounce(func, delay = 100) {
    let timer;
    return function(event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, delay, event);
    };
}
const findClosestEdge = (ev, el)=>{
    if (!el) return;
    const wrapperRect = el.getBoundingClientRect();
    const x = ev.clientX - wrapperRect.left;
    const y = ev.clientY - wrapperRect.top;
    return closestEdge(x, y, el.clientWidth, el.clientHeight);
};
const closestEdge = (x, y, w, h)=>{
    const topEdgeDist = distMetric(x, y, w / 2, 0);
    const bottomEdgeDist = distMetric(x, y, w / 2, h);
    const min = Math.min(topEdgeDist, bottomEdgeDist);
    return min === topEdgeDist ? 'top' : 'bottom';
};
const distMetric = (x, y, x2, y2)=>{
    var xDiff = x - x2;
    var yDiff = y - y2;
    return xDiff * xDiff + yDiff * yDiff;
};
class FloatingAnimation {
    random(min, max) {
        return (direction = 1)=>(max - Math.random() * (max - min)) * direction;
    }
    moveX(selector, direction) {
        gsap.to(selector, {
            duration: this.random(this.duration * 0.5, this.duration),
            x: this.random(this.x * 0.1, this.x),
            ease: 'sine.inOut',
            onComplete: this.moveX.bind(this),
            onCompleteParams: [
                selector,
                direction * -1
            ]
        });
    }
    moveY(selector, direction) {
        gsap.to(selector, {
            duration: this.random(this.y * 0.1, this.y),
            y: this.random(this.y * 0.1, this.y),
            ease: 'sine.inOut',
            onComplete: this.moveY.bind(this),
            onCompleteParams: [
                selector,
                direction * -1
            ]
        });
    }
    rotate(selector, direction) {
        gsap.to(selector, {
            duration: this.random(this.x * 0.1, this.x),
            rotation: this.random(this.angle * 0.1, this.angle),
            ease: 'sine.inOut',
            onComplete: this.rotate.bind(this),
            onCompleteParams: [
                selector,
                direction * -1
            ]
        });
    }
    constructor(target, x, y, angle, duration){
        this.target = $(target);
        this.x = x || 50;
        this.y = y || 50;
        this.angle = angle || 15;
        this.duration = duration || 10;
        this.randomX = this.random(this.x * 0.1, this.x);
        this.randomY = this.random(this.y * 0.1, this.y);
        this.randomAngle = this.random(this.angle * 0.1, this.angle);
        this.randomMoveTime = this.random(this.duration * 0.5, this.duration);
        this.randomRotateTime = this.random(this.duration, this.duration * 2);
        gsap.set(this.target, {
            transformOrigin: "center center"
        });
        this.moveX(this.target, Math.random() < 0.5 ? 1 : -1);
        this.moveY(this.target, Math.random() < 0.5 ? 1 : -1);
        this.rotate(this.target, Math.random() < 0.5 ? 1 : -1);
    }
}

},{"../helper/viewport":"e5DfO","@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"e5DfO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "viewportBreak", ()=>viewportBreak);
parcelHelpers.export(exports, "isTouchDevice", ()=>isTouchDevice);
parcelHelpers.export(exports, "cvUnit", ()=>cvUnit);
parcelHelpers.export(exports, "percentage", ()=>percentage);
let viewport = {
    width: $(window).width(),
    height: $(window).height(),
    pixelRatio: window.devicePixelRatio
};
const device = {
    tablet: 991,
    mobile: 767
};
const viewportBreak = (callbacks)=>{
    const { desktop, tablet, mobile } = callbacks;
    let result;
    switch(true){
        case viewport.width >= device.tablet:
            result = callbacks.desktop;
            break;
        case viewport.width >= device.mobile:
            result = callbacks.tablet;
            break;
        default:
            result = callbacks.mobile;
            break;
    }
    return result instanceof Function ? result() : result;
};
const cvUnit = (val, unit)=>{
    let result;
    switch(true){
        case unit === 'vw':
            result = $(window).width() * (val / 100);
            break;
        case unit === 'vh':
            result = $(window).height() * (val / 100);
            break;
        case unit === 'rem':
            result = val / 10 * parseFloat($('html').css('font-size'));
            break;
        default:
            break;
    }
    return result;
};
const percentage = (percent, total)=>(percent / 100 * total).toFixed(2);
const isTouchDevice = ()=>{
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"3toiX":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"2RIXr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lenis", ()=>lenis);
parcelHelpers.export(exports, "initLenis", ()=>initLenis);
gsap.registerPlugin(ScrollTrigger);
let lenis;
const initLenis = ()=>{
    lenis = new Lenis({
        lerp: 0.05
    });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add((time)=>{
        lenis.raf(time * 1500);
    });
    gsap.ticker.lagSmoothing(0);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"cLlMb":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    'use strict';
    var emojiExp = /([\uD800-\uDBFF][\uDC00-\uDFFF](?:[\u200D\uFE0F][\uD800-\uDBFF][\uDC00-\uDFFF]){2,}|\uD83D\uDC69(?:\u200D(?:(?:\uD83D\uDC69\u200D)?\uD83D\uDC67|(?:\uD83D\uDC69\u200D)?\uD83D\uDC66)|\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D(?:\uD83D\uDC69\u200D)?\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D(?:\uD83D\uDC69\u200D)?\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]\uFE0F|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC6F\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3C-\uDD3E\uDDD6-\uDDDF])\u200D[\u2640\u2642]\uFE0F|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F\u200D[\u2640\u2642]|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642])\uFE0F|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC69\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708]))\uFE0F|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83D\uDC69\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC66\u200D\uD83D\uDC66|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]))|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\u200D(?:(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC67|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC66)|\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDD1-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])?|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])\uFE0F)/;
    function getText(e) {
        var type = e.nodeType, result = "";
        if (type === 1 || type === 9 || type === 11) {
            if (typeof e.textContent === "string") return e.textContent;
            else for(e = e.firstChild; e; e = e.nextSibling)result += getText(e);
        } else if (type === 3 || type === 4) return e.nodeValue;
        return result;
    }
    /*!
	 * SplitText: 3.9.1
	 * https://greensock.com
	 *
	 * @license Copyright 2008-2021, GreenSock. All rights reserved.
	 * Subject to the terms at https://greensock.com/standard-license or for
	 * Club GreenSock members, the agreement issued with that membership.
	 * @author: Jack Doyle, jack@greensock.com
	*/ var _doc, _win, _coreInitted, _stripExp = /(?:\r|\n|\t\t)/g, _multipleSpacesExp = /(?:\s\s+)/g, _initCore = function _initCore() {
        _doc = document;
        _win = window;
        _coreInitted = 1;
    }, _getComputedStyle = function _getComputedStyle(element) {
        return _win.getComputedStyle(element);
    }, _isArray = Array.isArray, _slice = [].slice, _toArray = function _toArray(value, leaveStrings) {
        var type;
        return _isArray(value) ? value : (type = typeof value) === "string" && !leaveStrings && value ? _slice.call(_doc.querySelectorAll(value), 0) : value && type === "object" && "length" in value ? _slice.call(value, 0) : value ? [
            value
        ] : [];
    }, _isAbsolute = function _isAbsolute(vars) {
        return vars.position === "absolute" || vars.absolute === true;
    }, _findSpecialChars = function _findSpecialChars(text, chars) {
        var i = chars.length, s;
        while(--i > -1){
            s = chars[i];
            if (text.substr(0, s.length) === s) return s.length;
        }
    }, _divStart = " style='position:relative;display:inline-block;'", _cssClassFunc = function _cssClassFunc(cssClass, tag) {
        if (cssClass === void 0) cssClass = "";
        var iterate = ~cssClass.indexOf("++"), num = 1;
        if (iterate) cssClass = cssClass.split("++").join("");
        return function() {
            return "<" + tag + _divStart + (cssClass ? " class='" + cssClass + (iterate ? num++ : "") + "'>" : ">");
        };
    }, _swapText = function _swapText(element, oldText, newText) {
        var type = element.nodeType;
        if (type === 1 || type === 9 || type === 11) for(element = element.firstChild; element; element = element.nextSibling)_swapText(element, oldText, newText);
        else if (type === 3 || type === 4) element.nodeValue = element.nodeValue.split(oldText).join(newText);
    }, _pushReversed = function _pushReversed(a, merge) {
        var i = merge.length;
        while(--i > -1)a.push(merge[i]);
    }, _isBeforeWordDelimiter = function _isBeforeWordDelimiter(e, root, wordDelimiter) {
        var next;
        while(e && e !== root){
            next = e._next || e.nextSibling;
            if (next) return next.textContent.charAt(0) === wordDelimiter;
            e = e.parentNode || e._parent;
        }
    }, _deWordify = function _deWordify(e) {
        var children = _toArray(e.childNodes), l = children.length, i, child;
        for(i = 0; i < l; i++){
            child = children[i];
            if (child._isSplit) _deWordify(child);
            else {
                if (i && child.previousSibling && child.previousSibling.nodeType === 3) {
                    child.previousSibling.nodeValue += child.nodeType === 3 ? child.nodeValue : child.firstChild.nodeValue;
                    e.removeChild(child);
                } else if (child.nodeType !== 3) {
                    e.insertBefore(child.firstChild, child);
                    e.removeChild(child);
                }
            }
        }
    }, _getStyleAsNumber = function _getStyleAsNumber(name, computedStyle) {
        return parseFloat(computedStyle[name]) || 0;
    }, _setPositionsAfterSplit = function _setPositionsAfterSplit(element, vars, allChars, allWords, allLines, origWidth, origHeight) {
        var cs = _getComputedStyle(element), paddingLeft = _getStyleAsNumber("paddingLeft", cs), lineOffsetY = -999, borderTopAndBottom = _getStyleAsNumber("borderBottomWidth", cs) + _getStyleAsNumber("borderTopWidth", cs), borderLeftAndRight = _getStyleAsNumber("borderLeftWidth", cs) + _getStyleAsNumber("borderRightWidth", cs), padTopAndBottom = _getStyleAsNumber("paddingTop", cs) + _getStyleAsNumber("paddingBottom", cs), padLeftAndRight = _getStyleAsNumber("paddingLeft", cs) + _getStyleAsNumber("paddingRight", cs), lineThreshold = _getStyleAsNumber("fontSize", cs) * (vars.lineThreshold || 0.2), textAlign = cs.textAlign, charArray = [], wordArray = [], lineArray = [], wordDelimiter = vars.wordDelimiter || " ", tag = vars.tag ? vars.tag : vars.span ? "span" : "div", types = vars.type || vars.split || "chars,words,lines", lines = allLines && ~types.indexOf("lines") ? [] : null, words = ~types.indexOf("words"), chars = ~types.indexOf("chars"), absolute = _isAbsolute(vars), linesClass = vars.linesClass, iterateLine = ~(linesClass || "").indexOf("++"), spaceNodesToRemove = [], isFlex = cs.display === "flex", prevInlineDisplay = element.style.display, i, j, l, node, nodes, isChild, curLine, addWordSpaces, style, lineNode, lineWidth, offset;
        iterateLine && (linesClass = linesClass.split("++").join(""));
        isFlex && (element.style.display = "block");
        j = element.getElementsByTagName("*");
        l = j.length;
        nodes = [];
        for(i = 0; i < l; i++)nodes[i] = j[i];
        if (lines || absolute) for(i = 0; i < l; i++){
            node = nodes[i];
            isChild = node.parentNode === element;
            if (isChild || absolute || chars && !words) {
                offset = node.offsetTop;
                if (lines && isChild && Math.abs(offset - lineOffsetY) > lineThreshold && (node.nodeName !== "BR" || i === 0)) {
                    curLine = [];
                    lines.push(curLine);
                    lineOffsetY = offset;
                }
                if (absolute) {
                    node._x = node.offsetLeft;
                    node._y = offset;
                    node._w = node.offsetWidth;
                    node._h = node.offsetHeight;
                }
                if (lines) {
                    if (node._isSplit && isChild || !chars && isChild || words && isChild || !words && node.parentNode.parentNode === element && !node.parentNode._isSplit) {
                        curLine.push(node);
                        node._x -= paddingLeft;
                        if (_isBeforeWordDelimiter(node, element, wordDelimiter)) node._wordEnd = true;
                    }
                    if (node.nodeName === "BR" && (node.nextSibling && node.nextSibling.nodeName === "BR" || i === 0)) lines.push([]);
                }
            }
        }
        for(i = 0; i < l; i++){
            node = nodes[i];
            isChild = node.parentNode === element;
            if (node.nodeName === "BR") {
                if (lines || absolute) {
                    node.parentNode && node.parentNode.removeChild(node);
                    nodes.splice(i--, 1);
                    l--;
                } else if (!words) element.appendChild(node);
                continue;
            }
            if (absolute) {
                style = node.style;
                if (!words && !isChild) {
                    node._x += node.parentNode._x;
                    node._y += node.parentNode._y;
                }
                style.left = node._x + "px";
                style.top = node._y + "px";
                style.position = "absolute";
                style.display = "block";
                style.width = node._w + 1 + "px";
                style.height = node._h + "px";
            }
            if (!words && chars) {
                if (node._isSplit) {
                    node._next = j = node.nextSibling;
                    node.parentNode.appendChild(node);
                    while(j && j.nodeType === 3 && j.textContent === " "){
                        node._next = j.nextSibling;
                        node.parentNode.appendChild(j);
                        j = j.nextSibling;
                    }
                } else if (node.parentNode._isSplit) {
                    node._parent = node.parentNode;
                    if (!node.previousSibling && node.firstChild) node.firstChild._isFirst = true;
                    if (node.nextSibling && node.nextSibling.textContent === " " && !node.nextSibling.nextSibling) spaceNodesToRemove.push(node.nextSibling);
                    node._next = node.nextSibling && node.nextSibling._isFirst ? null : node.nextSibling;
                    node.parentNode.removeChild(node);
                    nodes.splice(i--, 1);
                    l--;
                } else if (!isChild) {
                    offset = !node.nextSibling && _isBeforeWordDelimiter(node.parentNode, element, wordDelimiter);
                    node.parentNode._parent && node.parentNode._parent.appendChild(node);
                    offset && node.parentNode.appendChild(_doc.createTextNode(" "));
                    if (tag === "span") node.style.display = "inline";
                    charArray.push(node);
                }
            } else if (node.parentNode._isSplit && !node._isSplit && node.innerHTML !== "") wordArray.push(node);
            else if (chars && !node._isSplit) {
                if (tag === "span") node.style.display = "inline";
                charArray.push(node);
            }
        }
        i = spaceNodesToRemove.length;
        while(--i > -1)spaceNodesToRemove[i].parentNode.removeChild(spaceNodesToRemove[i]);
        if (lines) {
            if (absolute) {
                lineNode = _doc.createElement(tag);
                element.appendChild(lineNode);
                lineWidth = lineNode.offsetWidth + "px";
                offset = lineNode.offsetParent === element ? 0 : element.offsetLeft;
                element.removeChild(lineNode);
            }
            style = element.style.cssText;
            element.style.cssText = "display:none;";
            while(element.firstChild)element.removeChild(element.firstChild);
            addWordSpaces = wordDelimiter === " " && (!absolute || !words && !chars);
            for(i = 0; i < lines.length; i++){
                curLine = lines[i];
                lineNode = _doc.createElement(tag);
                lineNode.style.cssText = "display:block;text-align:" + textAlign + ";position:" + (absolute ? "absolute;" : "relative;");
                if (linesClass) lineNode.className = linesClass + (iterateLine ? i + 1 : "");
                lineArray.push(lineNode);
                l = curLine.length;
                for(j = 0; j < l; j++)if (curLine[j].nodeName !== "BR") {
                    node = curLine[j];
                    lineNode.appendChild(node);
                    addWordSpaces && node._wordEnd && lineNode.appendChild(_doc.createTextNode(" "));
                    if (absolute) {
                        if (j === 0) {
                            lineNode.style.top = node._y + "px";
                            lineNode.style.left = paddingLeft + offset + "px";
                        }
                        node.style.top = "0px";
                        if (offset) node.style.left = node._x - offset + "px";
                    }
                }
                if (l === 0) lineNode.innerHTML = "&nbsp;";
                else if (!words && !chars) {
                    _deWordify(lineNode);
                    _swapText(lineNode, String.fromCharCode(160), " ");
                }
                if (absolute) {
                    lineNode.style.width = lineWidth;
                    lineNode.style.height = node._h + "px";
                }
                element.appendChild(lineNode);
            }
            element.style.cssText = style;
        }
        if (absolute) {
            if (origHeight > element.clientHeight) {
                element.style.height = origHeight - padTopAndBottom + "px";
                if (element.clientHeight < origHeight) element.style.height = origHeight + borderTopAndBottom + "px";
            }
            if (origWidth > element.clientWidth) {
                element.style.width = origWidth - padLeftAndRight + "px";
                if (element.clientWidth < origWidth) element.style.width = origWidth + borderLeftAndRight + "px";
            }
        }
        isFlex && (prevInlineDisplay ? element.style.display = prevInlineDisplay : element.style.removeProperty("display"));
        _pushReversed(allChars, charArray);
        words && _pushReversed(allWords, wordArray);
        _pushReversed(allLines, lineArray);
    }, _splitRawText = function _splitRawText(element, vars, wordStart, charStart) {
        var tag = vars.tag ? vars.tag : vars.span ? "span" : "div", types = vars.type || vars.split || "chars,words,lines", chars = ~types.indexOf("chars"), absolute = _isAbsolute(vars), wordDelimiter = vars.wordDelimiter || " ", space = wordDelimiter !== " " ? "" : absolute ? "&#173; " : " ", wordEnd = "</" + tag + ">", wordIsOpen = 1, specialChars = vars.specialChars ? typeof vars.specialChars === "function" ? vars.specialChars : _findSpecialChars : null, text, splitText, i, j, l, character, hasTagStart, testResult, container = _doc.createElement("div"), parent = element.parentNode;
        parent.insertBefore(container, element);
        container.textContent = element.nodeValue;
        parent.removeChild(element);
        element = container;
        text = getText(element);
        hasTagStart = text.indexOf("<") !== -1;
        if (vars.reduceWhiteSpace !== false) text = text.replace(_multipleSpacesExp, " ").replace(_stripExp, "");
        if (hasTagStart) text = text.split("<").join("{{LT}}");
        l = text.length;
        splitText = (text.charAt(0) === " " ? space : "") + wordStart();
        for(i = 0; i < l; i++){
            character = text.charAt(i);
            if (specialChars && (testResult = specialChars(text.substr(i), vars.specialChars))) {
                character = text.substr(i, testResult || 1);
                splitText += chars && character !== " " ? charStart() + character + "</" + tag + ">" : character;
                i += testResult - 1;
            } else if (character === wordDelimiter && text.charAt(i - 1) !== wordDelimiter && i) {
                splitText += wordIsOpen ? wordEnd : "";
                wordIsOpen = 0;
                while(text.charAt(i + 1) === wordDelimiter){
                    splitText += space;
                    i++;
                }
                if (i === l - 1) splitText += space;
                else if (text.charAt(i + 1) !== ")") {
                    splitText += space + wordStart();
                    wordIsOpen = 1;
                }
            } else if (character === "{" && text.substr(i, 6) === "{{LT}}") {
                splitText += chars ? charStart() + "{{LT}}" + "</" + tag + ">" : "{{LT}}";
                i += 5;
            } else if (character.charCodeAt(0) >= 0xD800 && character.charCodeAt(0) <= 0xDBFF || text.charCodeAt(i + 1) >= 0xFE00 && text.charCodeAt(i + 1) <= 0xFE0F) {
                j = ((text.substr(i, 12).split(emojiExp) || [])[1] || "").length || 2;
                splitText += chars && character !== " " ? charStart() + text.substr(i, j) + "</" + tag + ">" : text.substr(i, j);
                i += j - 1;
            } else splitText += chars && character !== " " ? charStart() + character + "</" + tag + ">" : character;
        }
        element.outerHTML = splitText + (wordIsOpen ? wordEnd : "");
        hasTagStart && _swapText(parent, "{{LT}}", "<");
    }, _split = function _split(element, vars, wordStart, charStart) {
        var children = _toArray(element.childNodes), l = children.length, absolute = _isAbsolute(vars), i, child;
        if (element.nodeType !== 3 || l > 1) {
            vars.absolute = false;
            for(i = 0; i < l; i++){
                child = children[i];
                child._next = child._isFirst = child._parent = child._wordEnd = null;
                if (child.nodeType !== 3 || /\S+/.test(child.nodeValue)) {
                    if (absolute && child.nodeType !== 3 && _getComputedStyle(child).display === "inline") {
                        child.style.display = "inline-block";
                        child.style.position = "relative";
                    }
                    child._isSplit = true;
                    _split(child, vars, wordStart, charStart);
                }
            }
            vars.absolute = absolute;
            element._isSplit = true;
            return;
        }
        _splitRawText(element, vars, wordStart, charStart);
    };
    var SplitText = function() {
        function SplitText(element, vars) {
            _coreInitted || _initCore();
            this.elements = _toArray(element);
            this.chars = [];
            this.words = [];
            this.lines = [];
            this._originals = [];
            this.vars = vars || {};
            this.split(vars);
        }
        var _proto = SplitText.prototype;
        _proto.split = function split(vars) {
            this.isSplit && this.revert();
            this.vars = vars = vars || this.vars;
            this._originals.length = this.chars.length = this.words.length = this.lines.length = 0;
            var i = this.elements.length, tag = vars.tag ? vars.tag : vars.span ? "span" : "div", wordStart = _cssClassFunc(vars.wordsClass, tag), charStart = _cssClassFunc(vars.charsClass, tag), origHeight, origWidth, e;
            while(--i > -1){
                e = this.elements[i];
                this._originals[i] = e.innerHTML;
                origHeight = e.clientHeight;
                origWidth = e.clientWidth;
                _split(e, vars, wordStart, charStart);
                _setPositionsAfterSplit(e, vars, this.chars, this.words, this.lines, origWidth, origHeight);
            }
            this.chars.reverse();
            this.words.reverse();
            this.lines.reverse();
            this.isSplit = true;
            return this;
        };
        _proto.revert = function revert() {
            var originals = this._originals;
            if (!originals) throw "revert() call wasn't scoped properly.";
            this.elements.forEach(function(e, i) {
                return e.innerHTML = originals[i];
            });
            this.chars = [];
            this.words = [];
            this.lines = [];
            this.isSplit = false;
            return this;
        };
        SplitText.create = function create(element, vars) {
            return new SplitText(element, vars);
        };
        return SplitText;
    }();
    SplitText.version = "3.9.1";
    exports1.SplitText = SplitText;
    exports1.default = SplitText;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

},{}],"l135N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../../helper/index");
var _success = require("../../api/success");
var _planDataJson = require("../../../../plan-data.json");
var _planDataJsonDefault = parcelHelpers.interopDefault(_planDataJson);
const payment_success = {
    namespace: "payment_success",
    afterEnter (data) {
        console.log(`enter ${this.namespace}`);
        let successWrapClone = $('.success-wrap').clone();
        // gsap.set(successWrapClone, { autoAlpha: 0, y: 10 });
        $('.success-wrap').remove();
        let params = new URL(document.location).searchParams;
        let session_id = params.get("session_id");
        let payment_id = params.get('payment_id');
        let successSelector = (0, _index.selector)(successWrapClone);
        const successFormResult = async ()=>{
            let data_payment_result = await (0, _success.getPaymentResult)(session_id);
            let totalPrice = (data_payment_result.amount_total / 100).toLocaleString();
            successSelector('[data-payment-price]').text(totalPrice);
            let options = {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            };
            let expiresAt = new Date(data_payment_result.expires_at * 1000).toLocaleDateString('en-GB', options).replace(/(\d{2}) (\w{3})/, '$1 $2,');
            successSelector('[data-payment-expires]').text(expiresAt);
            successSelector('[data-payment-plan]').text((0, _planDataJsonDefault.default)[payment_id].name.split(" ").at(0));
            successSelector('[data-payment-periodic]').text(`/${(0, _planDataJsonDefault.default)[payment_id].name.split(" ").at(-1).toLowerCase()}`);
            successSelector('[data-payment-scope]').text((0, _planDataJsonDefault.default)[payment_id].scope);
        };
        const showSuccessForm = ()=>{
            let tl = gsap.timeline();
            $('.main.success').append(successWrapClone);
            tl.from('.success-bg', {
                autoAlpha: 0.5,
                duration: 2
            }).from(successSelector('.success-popup'), {
                autoAlpha: 0,
                y: 15,
                ease: 'power1.out',
                duration: 1
            }, 0).from(successSelector('.success-thanks'), {
                autoAlpha: 0,
                y: 15,
                ease: 'power1.out',
                duration: .8
            }, ">=-0.6").from(successSelector('.success-back'), {
                autoAlpha: 0,
                y: 15,
                ease: 'power1.out',
                duration: .8
            }, ">=-0.6").from(successSelector('.success-contact'), {
                autoAlpha: 0,
                ease: 'power1.out',
                duration: 1
            }, ">=-0.5");
        };
        async function successMain() {
            await successFormResult();
            await showSuccessForm();
        }
        successMain();
    },
    beforeLeave (data) {
        console.log(`leave ${this.namespace}`);
    }
};
exports.default = payment_success;

},{"../../helper/index":"lOTX9","../../api/success":"18e0P","../../../../plan-data.json":"b93UM","@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"18e0P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPaymentResult", ()=>getPaymentResult);
parcelHelpers.export(exports, "getPaymentDetail", ()=>getPaymentDetail);
const ApiCall = async ({ url, path, method = 'GET', data = {}, token, router, contentType = null, headers = {}, ...params })=>{
    let api;
    let options = {
        method: method,
        headers: {
            ...headers
        },
        ...params
    };
    try {
        api = await fetch(`http://localhost:4000/${path}`, options);
    } catch (e) {
        api = e.response;
    }
    if (api.ok) return api.json();
    else return api.json().then((json)=>Promise.reject(json));
    return api;
};
const getPaymentResult = async (id)=>{
    let { data } = await ApiCall({
        path: 'get-payment',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            session: [
                {
                    id: id
                }
            ]
        })
    });
    return data;
};
const getPaymentDetail = async (id)=>{
    console.log(id);
    let { data } = await ApiCall({
        path: 'get-payment-detail',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            payment: [
                {
                    id: id
                }
            ]
        })
    });
    return data;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"b93UM":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("[{\"priceId\":\"price_1OgOlkAyaaWxy2CsqsoJipuR\",\"name\":\"Trial 7 days\",\"method\":\"payment\",\"scope\":\"Design Only\"},{\"priceId\":\"price_1OfJjyAyaaWxy2CsH7LieoXV\",\"name\":\"Standard Monthly\",\"method\":\"subscription\",\"scope\":\"Design Only\"},{\"priceId\":\"price_1OgOfAAyaaWxy2CsHMFYrhRS\",\"name\":\"Standard Quarterly\",\"method\":\"subscription\",\"scope\":\"Design Only\"},{\"priceId\":\"price_1OgOgRAyaaWxy2CsaQOuzcu3\",\"name\":\"Standard Yearly\",\"method\":\"subscription\",\"scope\":\"Design Only\"},{\"priceId\":\"price_1OgOibAyaaWxy2CsxHJUR1MI\",\"name\":\"Pro Monthly\",\"method\":\"subscription\",\"scope\":\"Design & Development\"},{\"priceId\":\"price_1OgOkKAyaaWxy2Cs6A2eJGKE\",\"name\":\"Pro Quarterly\",\"method\":\"subscription\",\"scope\":\"Design & Development\"},{\"priceId\":\"price_1OgOl3AyaaWxy2Csxdyz1Lbn\",\"name\":\"Pro Yearly\",\"method\":\"subscription\",\"scope\":\"Design & Development\"}]");

},{}],"2cZNX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const term = {
    namespace: "term",
    afterEnter (data) {
        console.log(`enter ${this.namespace}`);
    },
    beforeLeave (data) {
        console.log(`enter ${this.namespace}`);
    }
};
exports.default = term;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"jlU6O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../../helper/index");
const thank_you = {
    namespace: "thank_you",
    afterEnter (data) {
        console.log(`enter ${this.namespace}`);
    // let thankYouWrapClone = $('.thank-you-wrap').clone();
    // let thankYouSelector = selector(thankYouWrapClone);
    // // gsap.set(thankYou, { autoAlpha: 0, y: 10 });
    // $('.thank-you-wrap').remove();
    // const showThankYouForm = () => {
    //     let tl = gsap.timeline();
    //     $('.main.thank-you').append(thankYouWrapClone);
    //     tl
    //     .from('.thank-you-bg', {
    //         autoAlpha: 0.5, duration: 2
    //     })
    //     .from(thankYouSelector('.thank-you-popup'), {
    //         autoAlpha: 0, y: 15, ease: 'power1.out', duration: 1
    //     }, 0).from(thankYouSelector('.thank-you-thanks'), {
    //         autoAlpha: 0, y: 15, ease: 'power1.out', duration: .8
    //     }, ">=-0.6")
    //     .from(thankYouSelector('.thank-you-back'), {
    //         autoAlpha: 0, y: 15, ease: 'power1.out', duration: .8
    //     }, ">=-0.6")
    //     .from(thankYouSelector('.thank-you-contact'), {
    //         autoAlpha: 0, ease: 'power1.out', duration: 1
    //     }, ">=-0.5")
    // }
    // function thankYouMain() {
    //     showThankYouForm();
    // }
    // thankYouMain();
    },
    beforeLeave (data) {
        console.log(`leave ${this.namespace}`);
    }
};
exports.default = thank_you;

},{"../../helper/index":"lOTX9","@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"ku2ku":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _header = require("./header");
var _headerDefault = parcelHelpers.interopDefault(_header);
var _footer = require("./footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _popup = require("./popup");
var _popupDefault = parcelHelpers.interopDefault(_popup);
var _magicMouse = require("./magic-mouse");
var _magicMouseDefault = parcelHelpers.interopDefault(_magicMouse);
var _glowBorder = require("./glow-border");
var _glowBorderDefault = parcelHelpers.interopDefault(_glowBorder);
var _lenis = require("./lenis");
var _button = require("./button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _refresh = require("./refresh");
var _refreshDefault = parcelHelpers.interopDefault(_refresh);
const initGlobal = ()=>{
    (0, _lenis.initLenis)();
    if ($(window).width() > 991) (0, _magicMouseDefault.default)();
    (0, _refreshDefault.default)();
    (0, _popupDefault.default)();
    (0, _buttonDefault.default)();
    (0, _headerDefault.default)();
    (0, _footerDefault.default)();
    (0, _glowBorderDefault.default)();
};
exports.default = initGlobal;

},{"./header":"3rah9","./footer":"f63z9","./popup":"1Oc6e","./magic-mouse":"al8PH","./glow-border":"areWd","./lenis":"2RIXr","./button":"afhgQ","./refresh":"b2BNP","@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"3rah9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../helper/index");
var _lenis = require("../global/lenis");
var _viewport = require("../helper/viewport");
var _splitText = require("../libs/SplitText");
const setupDot = ()=>{
    let allSections = $('[data-section]');
    let tempLabel = $('.header-menu-label-item').eq(0).clone();
    let tempProg = $('.header-menu-prog-item-wrap').eq(0).clone();
    $('.header-menu-label').find('.header-menu-label-item').remove();
    $('.header-menu-prog').find('.header-menu-prog-item-wrap').remove();
    allSections.each((idx, el)=>{
        let htmlLabel = tempLabel.clone();
        htmlLabel.attr('data-header-id', `${$(el).attr('data-section-id')}`);
        htmlLabel.find('span').text(`${$(el).attr('data-section-id')}`);
        $('.header-menu-label').append(htmlLabel);
        let htmlProg = tempProg.clone();
        htmlProg.attr('href', `#${$(el).attr('data-section-id')}`);
        htmlProg.attr('data-header-id', `${$(el).attr('data-section-id')}`);
        $('.header-menu-prog').append(htmlProg);
    });
};
const updateProgressByScroll = ()=>{
    let allSections = $('[data-section]');
    const DOM = {
        labelItem: $('.header-menu-label-item'),
        labelById: (id)=>$(`.header-menu-label-item[data-header-id="${id}"]`),
        labelSMById: (id)=>$(`.header-menu-sm-list [data-header-id="${id}"]`),
        progWrap: $(`.header-menu-prog-item-wrap`),
        progItem: $(`.header-menu-prog-item`),
        progById: (id)=>$(`.header-menu-prog-item-wrap[data-header-id="${id}"]`)
    };
    setTimeout(()=>{
        let offset = '40%';
        allSections.each((idx, el)=>{
            ScrollTrigger.create({
                trigger: el,
                start: `top top+=${offset}`,
                end: `bottom bottom-=${offset}`,
                scrub: true,
                onUpdate: (self)=>{
                    let currSection = allSections.eq(idx);
                    let id = currSection.attr('data-section-id');
                    if ($(window).width() > 767) {
                        DOM.labelById(id).addClass('active');
                        DOM.labelItem.not(DOM.labelById(id)).removeClass('active');
                        DOM.progById(id).addClass('active');
                        DOM.progWrap.not(DOM.progById(id)).removeClass('active');
                        DOM.progById(id).find(DOM.progItem).addClass('active');
                        DOM.progWrap.not(DOM.progById(id)).find(DOM.progItem).removeClass('active');
                        let percent = Math.ceil(self.progress * 100 - 100);
                        gsap.to(DOM.progById(id).find('.header-menu-prog-item-inner'), {
                            xPercent: percent,
                            duration: .3,
                            overwrite: true
                        });
                    } else {
                        $('.header-menu-sm-list a').removeClass('active');
                        DOM.labelSMById(id).addClass('active');
                        gsap.set('.header-menu-sm-process-inner-line', {
                            top: `${idx * ($('.header-menu-sm-process-inner').height() - $('.header-menu-sm-process-inner-line').height()) / (allSections.length - 1) / $('.header-menu-sm-process-inner').height() * 100}%`
                        });
                    }
                }
            });
        });
        ScrollTrigger.create({
            trigger: '.home-main',
            start: `top top+=${offset}`,
            end: `bottom bottom-=${offset}`,
            onLeave: ()=>{
                $(`.header-menu-label-item`).removeClass('active');
                $(`.header-menu-prog-item`).removeClass('active');
            },
            onLeaveBack: ()=>{
                $(`.header-menu-label-item`).removeClass('active');
                $(`.header-menu-prog-item`).removeClass('active');
            }
        });
    }, 100);
    $('.header-main [data-header-id]').on('click', function(e) {
        let target = $(this).attr('data-header-id');
        if ($('html').hasClass('lenis-smooth')) (0, _lenis.lenis).scrollTo(`[data-section-id="${target}"]`);
        else {
            let targetTop = $(`[data-section-id="${target}"]`).get(0).offsetTop + $(window).height();
            $('html').animate({
                scrollTop: targetTop
            });
        }
        history.replaceState({}, '', `${window.location.pathname}#${target}`);
        return false;
    });
    const checkMenuActive = ()=>{
        if ($('.header-menu-label').length) {
            if ($('.header-menu-label-item.active').length === 0) gsap.set('.header-menu-label', {
                '--d-width': '0px'
            });
            else gsap.set('.header-menu-label', {
                '--d-width': `${$('.header-menu-label-item.active').eq(0).width()}px`
            });
            requestAnimationFrame(checkMenuActive);
        }
    };
    requestAnimationFrame(checkMenuActive);
};
const hoverDot = ()=>{
    $('.header-menu-prog-item-wrap').on('mouseenter', function(e) {
        let content = $(this).attr('data-header-id');
        $('.header-menu-prog-label').text(content);
        gsap.to('.header-menu-prog-label', {
            autoAlpha: 1
        });
    });
    $('.header-menu-prog-item-wrap').on('mouseleave', function(e) {
        gsap.to('.header-menu-prog-label', {
            autoAlpha: 0
        });
    });
};
function checkHoverDot() {
    if ($('.header-menu-prog-item-wrap:hover').length) {
        let target = $('.header-menu-prog-item-wrap:hover');
        let currX = (0, _index.xGetter)('.header-menu-prog-label');
        (0, _index.xSetter)('.header-menu-prog-label')((0, _index.lerp)(currX, target.get(0).offsetLeft - $('.header-menu-prog-label').outerWidth() / 2 + target.outerWidth() / 2));
    }
    requestAnimationFrame(checkHoverDot);
}
const updateHeaderBarByScroll = ()=>{
    if ($('.home-main').length) {
        let offsetHeaderMain = $('.header-main').offset().left;
        let tlHeaderTrigger = gsap.timeline({
            scrollTrigger: {
                trigger: '.home-main',
                start: `top+=${$('.header').outerHeight()} top`,
                onEnter: ()=>{
                    $('.header-logo').addClass('active');
                    if ($(window).width() > 767) {
                        $('.header-menu').addClass('active');
                        $('.header-hamburger').addClass('active');
                        if ($(window).width() <= 991) {
                            gsap.to('.header-main-schedule', {
                                width: 0,
                                overwrite: true
                            });
                            gsap.to('.header-hamburger', {
                                width: 0,
                                overwrite: true
                            });
                            gsap.to('.header-menu-label', {
                                marginLeft: '1rem'
                            });
                        }
                    }
                    if ($(window).width() <= 767) {
                        gsap.to('.header-main', {
                            marginRight: 0
                        });
                        gsap.to('.header-hamburger', {
                            width: (0, _viewport.cvUnit)(60, "rem"),
                            overwrite: true
                        });
                        gsap.to('.header-main-inner', {
                            paddingLeft: (0, _viewport.cvUnit)(3.2, "rem")
                        });
                        gsap.to('.header-logo', {
                            width: 'auto',
                            marginRight: (0, _viewport.cvUnit)(32, "rem")
                        });
                    }
                },
                onLeaveBack: ()=>{
                    $('.header-logo').removeClass('active');
                    $('.header-hamburger').removeClass('active');
                    $('.header-menu-sm').slideUp(400);
                    if ($(window).width() > 767) $('.header-menu').removeClass('active');
                    if ($(window).width() <= 991) {
                        gsap.to('.header-main-schedule', {
                            width: 'auto',
                            overwrite: true
                        });
                        gsap.to('.header-hamburger', {
                            width: (0, _viewport.cvUnit)(60, "rem"),
                            overwrite: true
                        });
                        gsap.to('.header-menu-label', {
                            marginLeft: '0'
                        });
                    }
                    if ($(window).width() <= 767) {
                        gsap.to('.header-main', {
                            marginRight: offsetHeaderMain
                        });
                        gsap.to('.header-hamburger', {
                            width: 0,
                            overwrite: true
                        });
                        gsap.to('.header-main-inner', {
                            clearProps: 'padding-left'
                        });
                        gsap.to('.header-logo', {
                            width: 0,
                            marginRight: 0
                        });
                    }
                }
            }
        });
    }
    $('.header-menu-sm').slideUp(50);
    $('.header-hamburger').on('click', function(e) {
        e.preventDefault();
        if (!$(this).hasClass('active')) {
            if ($(window).width() > 767) {
                $('.header-menu').addClass('active');
                if ($(window).width() <= 991) gsap.to('.header-menu-label', {
                    marginLeft: '1rem'
                });
            } else {
                $('.header-menu-sm').slideDown({
                    start: function() {
                        $(this).css({
                            display: "flex"
                        });
                    }
                });
                gsap.set('.header-menu-sm-process-inner-line', {
                    top: `${$('[data-section]').length / 2 * ($('.header-menu-sm-process-inner').height() - $('.header-menu-sm-process-inner-line').height()) / ($('[data-section]').length - 1) / $('.header-menu-sm-process-inner').height() * 100}%`
                });
            }
            $(this).addClass('active');
        } else {
            if ($(window).width() > 767) {
                $('.header-menu').removeClass('active');
                if ($(window).width() <= 991) gsap.to('.header-menu-label', {
                    marginLeft: '0'
                });
            } else $('.header-menu-sm').slideUp(400);
            $(this).removeClass('active');
        }
    });
    if ($(window).width() <= 767) $('html').on('click', function(e) {
        if (!$('.header:hover').length) {
            $('.header-menu').removeClass('active');
            $('.header-menu-sm').slideUp(400);
            $('.header-hamburger').removeClass('active');
        }
    });
};
const header = {
    setup () {
        setupDot();
    },
    init () {
        updateProgressByScroll();
        updateHeaderBarByScroll();
        if ($(window).width() > 991) {
            hoverDot();
            checkHoverDot();
        }
    }
};
const initHeader = ()=>{
    header.setup();
    header.init();
};
exports.default = initHeader;

},{"../helper/index":"lOTX9","../global/lenis":"2RIXr","../helper/viewport":"e5DfO","../libs/SplitText":"cLlMb","@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"f63z9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../helper/index");
var _marquee = require("../common/marquee");
var _lenis = require("./lenis");
var _viewport = require("../helper/viewport");
const initFooter = ()=>{
    (0, _marquee.marqueeCSS)({
        parent: (0, _index.selector)('.footer-brands'),
        duration: 10
    });
    const curtainFooter = ()=>{
        let curtainHeight = $('.footer-curtain').height();
        let tl = gsap.timeline({
            data: 'footer-curtain',
            scrollTrigger: {
                trigger: '.footer-curtain',
                start: 'top bottom',
                endTrigger: '.footer',
                end: `bottom bottom+=${-curtainHeight}`,
                scrub: .2
            }
        });
        tl.from('.footer-curtain--inner', {
            scaleY: 0,
            stagger: {
                amount: -0.35
            },
            delay: .2,
            ease: 'power1.inOut'
        });
        return tl;
    };
    curtainFooter();
    const parallaxBear = ()=>{
        let target = $('.footer-curtain-logo');
        let tarCurrX = (0, _index.xGetter)(target.get(0));
        let tarCurrY = (0, _index.yGetter)(target.get(0));
        let tarCurrRotz = (0, _index.rotZGetter)(target.get(0));
        if (target.hasClass('active')) {
            let moveX = ((0, _index.pointerCurr)().x / $(window).width() - 0.5) * ($(window).width() - target.width() - (0, _viewport.cvUnit)(60, 'rem'));
            let moveY = ((0, _index.pointerCurr)().y / $(window).height() - 0.5) * 2 * (target.height() / 8);
            (0, _index.xSetter)(target.get(0))((0, _index.lerp)(tarCurrX, moveX, .02));
            (0, _index.ySetter)(target.get(0))((0, _index.lerp)(tarCurrY, moveY, .02));
            (0, _index.rotZSetter)(target.get(0))((0, _index.lerp)(tarCurrRotz, Math.min(Math.max((moveX - tarCurrX) / 80, -7), 7), .08));
        } else {
            (0, _index.xSetter)(target.get(0))((0, _index.lerp)(tarCurrX, 0, .02));
            (0, _index.ySetter)(target.get(0))((0, _index.lerp)(tarCurrY, 0, .02));
            (0, _index.rotZSetter)(target.get(0))((0, _index.lerp)(tarCurrRotz, 0, .08));
        }
        requestAnimationFrame(parallaxBear);
    };
    ScrollTrigger.create({
        trigger: '.footer',
        start: 'top bottom',
        end: 'bottom top',
        toggleClass: {
            targets: '.footer-curtain-logo',
            className: "active"
        },
        onEnter: ()=>{
            if ($(window).width() > 991) parallaxBear();
        }
    });
    $("[data-action='scrollTop']").on('click', function(e) {
        e.preventDefault();
        if (!(0, _viewport.isTouchDevice)()) (0, _lenis.lenis).scrollTo(0);
        else $('html').animate({
            scrollTop: 0
        });
    });
};
exports.default = initFooter;

},{"../helper/index":"lOTX9","../common/marquee":"4cdrA","./lenis":"2RIXr","../helper/viewport":"e5DfO","@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"4cdrA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "marqueeGS", ()=>marqueeGS);
parcelHelpers.export(exports, "marqueeCSS", ()=>marqueeCSS);
var _viewport = require("../helper/viewport");
const marqueeGS = (data)=>{
    const { parent, duration, start, stopWhenScroll } = data;
    const direction = {
        right: "-=",
        left: "+="
    };
    const DOM = {
        wrap: parent('.marquee'),
        list: parent('.marquee-inner'),
        item: parent('.marquee-inner-item')
    };
    let isHover = false;
    let tlMarquee = gsap.timeline({
        repeat: -1,
        // onReverseComplete() {
        //     this.totalTime(this.rawTime() + this.duration() * 10);
        // },
        onUpdate: ()=>{
            if (!isHover) {
                let tlDir = lenis.direction >= 0 ? 1 : -1;
                gsap.to(tlMarquee, {
                    timeScale: tlDir * Math.min(Math.max(lenis.velocity / 2, 1), 4),
                    duration: .1,
                    ease: 'none'
                });
            }
        }
    });
    ScrollTrigger.create({
        trigger: DOM.wrap,
        start: 'top bottom',
        once: true,
        onEnter: ()=>{
            let cloneAmount = 2;
            const cloneAdditional = Math.floor((0, _viewport.viewport).width / DOM.item.width());
            if (cloneAdditional >= 1) cloneAmount += cloneAdditional;
            DOM.item.css({
                position: "relative",
                top: 0,
                left: 0
            });
            gsap.set(DOM.item, {
                x: -1 * DOM.item.eq(0).width()
            });
            new Array(cloneAmount).fill().forEach((_, index)=>{
                let itemClone = DOM.item.clone();
                gsap.set(itemClone, {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    x: index * DOM.item.width(),
                    height: '100%'
                });
                DOM.list.append(itemClone);
            });
            tlMarquee.seek(28800);
            tlMarquee.to(DOM.list, {
                x: direction[start || "left"] + `${DOM.item.eq(0).width()}`,
                duration: DOM.item.eq(0).width() / duration,
                ease: "linear"
            });
        }
    });
    if (stopWhenScroll) {
        DOM.wrap.on("pointerenter", (event)=>{
            isHover = true;
            gsap.to(tlMarquee, {
                timeScale: 0,
                ease: 'power1.inOut',
                duration: 0.3,
                overwrite: true
            });
        });
        DOM.wrap.on("pointerleave", (event)=>{
            isHover = false;
            gsap.to(tlMarquee, {
                timeScale: 1,
                ease: 'power1.inOut',
                duration: 0.3,
                overwrite: true
            });
        });
    }
    return tlMarquee;
};
const marqueeCSS = (data)=>{
    const { parent, duration, start, delay, stopWhenScroll } = data;
    const direction = {
        right: "reverse",
        left: "normal"
    };
    const DOM = {
        wrap: parent('.marquee'),
        list: parent('.marquee-inner'),
        item: parent('.marquee-inner-item')
    };
    let cloneAmount = 2;
    const cloneAdditional = Math.floor((0, _viewport.viewport).width / DOM.item.width());
    if (cloneAdditional >= 1) cloneAmount += cloneAdditional;
    new Array(cloneAmount).fill().forEach((_, index)=>{
        let itemClone = DOM.item.clone();
        DOM.list.append(itemClone);
    });
    DOM.list.addClass('marquee-anim');
    gsap.set(parent('.marquee-anim'), {
        '--duration': DOM.item.width() / duration || parent('.marquee-anim').css('--duration'),
        '--direction': direction[start] || parent('.marquee-anim').css('--direction'),
        '--delay': delay || parent('.marquee-anim').css('--delay')
    });
    new Array(1).fill().forEach((_, index)=>{
        let itemClone = parent('.marquee-inner').clone();
        DOM.wrap.append(itemClone);
    });
};

},{"../helper/viewport":"e5DfO","@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"1Oc6e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lenis = require("./lenis");
const popup = (name)=>{
    let popupWrap = $(`[data-popup-${name}='wrap']`);
    const popupAction = {
        open: (el)=>{
            popupWrap.addClass('active');
            requestAnimationFrame(()=>$('.header-bar').addClass('force'));
        },
        close: ()=>{
            if (!popupWrap.hasClass('active')) return;
            setTimeout(()=>{
                popupWrap.removeClass('active');
                $('.header-bar').removeClass('force');
            }, 100);
            (0, _lenis.lenis).start();
        },
        update: (target)=>{
            $('.popup--sidebar-content').empty();
            let parent = $(target).closest('.home-benefit-item');
            let title = parent.find('.home-benefit-other-title').text();
            $('.popup--sidebar-header-heading').text(title);
            let cloner;
            parent.find('.home-benefit-other-sub-txt').each((idx, el)=>{
                cloner = $(el).clone();
                cloner.removeAttr('class');
                cloner.removeAttr('style');
                $('.popup--sidebar-content').append(cloner.clone());
            });
        }
    };
    $(`[data-popup-${name}]`).on('click', function(e) {
        if ($(this).attr(`data-popup-${name}`) === 'open') {
            e.preventDefault();
            popupAction.open(this);
            popupAction.update(this);
        } else if ($(this).attr(`data-popup-${name}`) === 'close') {
            e.preventDefault();
            (0, _lenis.lenis).start();
            popupAction.close();
        } else return;
    });
    $(window).on('click', (e)=>{
        if (!$(`[data-popup-${name}='wrap'] .popup-content>div:hover`).length) {
            if (!$(`[data-popup-${name}='open']:hover`).length) popupAction.close();
        }
    });
};
const initPopup = ()=>{
    popup('benefit');
    popup('contact');
};
exports.default = initPopup;

},{"./lenis":"2RIXr","@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"al8PH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../helper/index");
var _viewport = require("../helper/viewport");
const initCursor = ()=>{
    let cursorChange = false;
    let insideBgSc = false;
    const velChange = .12;
    let cursor = $('.cursor');
    let targetPos;
    let forcing = false;
    function initMouseMove() {
        let cursorX = (0, _index.xGetter)(cursor.get(0));
        let cursorY = (0, _index.yGetter)(cursor.get(0));
        let zRot = (0, _index.rotZGetter)(cursor.get(0));
        let scaleX = (0, _index.scaleXGetter)(cursor.get(0));
        let scaleY = (0, _index.scaleYGetter)(cursor.get(0));
        let dotX = (0, _index.xGetter)(cursor.find('.cursor-dot').get(0));
        let dotY = (0, _index.yGetter)(cursor.find('.cursor-dot').get(0));
        let borderX = (0, _index.xGetter)(cursor.find('.cursor-border').get(0));
        let borderY = (0, _index.yGetter)(cursor.find('.cursor-border').get(0));
        let glowX = (0, _index.xGetter)(cursor.find('.cursor-glow').get(0));
        let glowY = (0, _index.yGetter)(cursor.find('.cursor-glow').get(0));
        targetPos = {
            x: (0, _index.pointerCurr)().x,
            y: (0, _index.pointerCurr)().y
        };
        function updatePos(mode) {
            if (mode == "force") ;
            else {
                (0, _index.xSetter)(cursor.get(0))((0, _index.lerp)(cursorX, targetPos.x, .1));
                (0, _index.ySetter)(cursor.get(0))((0, _index.lerp)(cursorY, targetPos.y, .1));
            }
            (0, _index.xSetter)(cursor.find('.cursor-border').get(0))((0, _index.lerp)(borderX, -(targetPos.x - cursorX) / 20, .15));
            (0, _index.ySetter)(cursor.find('.cursor-border').get(0))((0, _index.lerp)(borderY, -(targetPos.y - cursorY) / 20, .15));
            (0, _index.xSetter)(cursor.find('.cursor-glow').get(0))((0, _index.lerp)(glowX, -(targetPos.x - cursorX) / 4, .1));
            (0, _index.ySetter)(cursor.find('.cursor-glow').get(0))((0, _index.lerp)(glowY, -(targetPos.y - cursorY) / 4, .1));
        }
        let showreelIc = $('.home-showreel-play-ic');
        let showreelIcX = (0, _index.xGetter)(showreelIc.get(0));
        let showreelIcY = (0, _index.yGetter)(showreelIc.get(0));
        let targetX, targetY;
        if ($('.home-showreel--wrap:hover').length) {
            if ($('[data-video="to-pause"]').length && $('.home-showreel-thumb:hover').length) {
                targetX = ((0, _index.pointerCurr)().x / $(window).width() - .5) * 2 * $(window).width() / 2;
                targetY = (((0, _index.pointerCurr)().y - $('.home-showreel-thumb').get(0).getBoundingClientRect().top) / $('.home-showreel-thumb').height() - 0.5) * $('.home-showreel-thumb').height();
                cursor.find('.cursor-dot').addClass('hide');
                cursor.find('.cursor-border').addClass('hide');
                cursor.find('.cursor-glow').addClass('hide');
                if (!showreelIc.hasClass('pause')) {
                    showreelIc.addClass('pause');
                    gsap.to(showreelIc, {
                        scale: .4,
                        autoAlpha: 1,
                        overwrite: true
                    });
                }
            } else {
                targetX = 0;
                targetY = 0;
                cursor.find('.cursor-dot').removeClass('hide');
                cursor.find('.cursor-border').removeClass('hide');
                cursor.find('.cursor-glow').removeClass('hide');
                if (showreelIc.hasClass('pause')) {
                    showreelIc.removeClass('pause');
                    gsap.to(showreelIc, {
                        scale: 1,
                        autoAlpha: 1,
                        overwrite: true
                    });
                }
            }
        } else {
            targetX = 0;
            targetY = 0;
        }
        if ($('[data-video="to-pause"]').length && !$('.home-showreel-thumb:hover').length) gsap.to(showreelIc, {
            scale: .4,
            autoAlpha: 0,
            overwrite: true
        });
        else if (showreelIc.hasClass('pause')) gsap.to(showreelIc, {
            scale: .4,
            autoAlpha: 1,
            overwrite: true
        });
        (0, _index.xSetter)(showreelIc.get(0))((0, _index.lerp)(showreelIcX, targetX, .1));
        (0, _index.ySetter)(showreelIc.get(0))((0, _index.lerp)(showreelIcY, targetY, .1));
        if ($('[data-cursor]:hover').length) {
            let target = $('[data-cursor]:hover');
            let targetOffsetLeft = target.get(0).getBoundingClientRect().left;
            let targetOffsetTop = target.get(0).getBoundingClientRect().top;
            let txtOffsetLeft, txtOffsetTop, dotOffsetLeft, dotOffsetTop;
            if (target.find('.txt').length) {
                txtOffsetLeft = target.find('.txt').get(0).getBoundingClientRect().left;
                txtOffsetTop = target.find('.txt').get(0).getBoundingClientRect().top;
            }
            if (target.find('[data-cursor-dotpos]').length) {
                dotOffsetLeft = target.find('[data-cursor-dotpos]').get(0).getBoundingClientRect().left;
                dotOffsetTop = target.find('[data-cursor-dotpos]').get(0).getBoundingClientRect().top;
            }
            let targetValue = {
                w: $('[data-cursor]:hover').outerWidth(),
                h: $('[data-cursor]:hover').outerHeight()
            };
            let type = target.attr('data-cursor');
            switch(type){
                case 'stick':
                    cursor.closest('.cursor-wrap').addClass('mixBlendMode');
                    cursor.find('.cursor-dot').addClass('stickstepdot');
                    cursor.find('.cursor-border').addClass('stickstepdot');
                    targetPos = {
                        x: targetOffsetLeft + target.outerWidth() / 2,
                        y: targetOffsetTop + target.outerHeight() / 2
                    };
                    (0, _index.xSetter)(cursor.get(0))((0, _index.lerp)(cursorX, targetOffsetLeft + target.outerWidth() / 2, velChange));
                    (0, _index.ySetter)(cursor.get(0))((0, _index.lerp)(cursorY, targetOffsetTop + target.outerHeight() / 2, velChange));
                    (0, _index.xSetter)(cursor.find('.cursor-border').get(0))((0, _index.lerp)(borderX, 0, velChange));
                    (0, _index.ySetter)(cursor.find('.cursor-border').get(0))((0, _index.lerp)(borderY, 0, velChange));
                    break;
                case 'radar':
                    cursor.find('.cursor-dot').addClass('hide');
                    targetPos = {
                        x: targetOffsetLeft + target.outerWidth() / 2,
                        y: targetOffsetTop + target.outerHeight() / 2
                    };
                    updatePos();
                    (0, _index.xSetter)(cursor.find('.cursor-border').get(0))((0, _index.lerp)(borderX, 0, .15));
                    (0, _index.ySetter)(cursor.find('.cursor-border').get(0))((0, _index.lerp)(borderY, 0, .15));
                    break;
                case 'hidden':
                    updatePos();
                    cursor.find('.cursor-dot').addClass('hide');
                    cursor.find('.cursor-border').addClass('hide');
                    cursor.find('.cursor-glow').addClass('hide');
                    break;
                case 'dotstick':
                    cursor.find('.cursor-dot').addClass('stickfaq');
                    targetPos = {
                        x: dotOffsetLeft + target.find('[data-cursor-dotpos]').outerWidth() / 2,
                        y: dotOffsetTop + target.find('[data-cursor-dotpos]').outerHeight() / 2
                    };
                    updatePos();
                    if (target.hasClass('hovered')) {
                        if (Math.abs(cursorY - targetPos.y) <= 1 || forcing == true) {
                            updatePos('force');
                            forcing = true;
                        }
                    } else {
                        forcing = false;
                        $(`[data-cursor="dotstick"]`).removeClass('hovered');
                        target.addClass('hovered');
                    }
                    break;
                case 'dotstickService':
                    cursor.find('.cursor-dot').addClass('stickService');
                    targetPos = {
                        x: dotOffsetLeft + target.find('[data-cursor-dotpos]').outerWidth() / 2,
                        y: dotOffsetTop + target.find('[data-cursor-dotpos]').outerHeight() / 2
                    };
                    updatePos();
                    if (target.hasClass('hovered')) {
                        if (Math.abs(cursorY - targetPos.y) <= 1 || forcing == true) {
                            updatePos('force');
                            forcing = true;
                        }
                    } else {
                        forcing = false;
                        $(`[data-cursor="dotstickService"]`).removeClass('hovered');
                        target.addClass('hovered');
                    }
                    break;
                case 'txtstick':
                    cursor.find('.cursor-dot').addClass('smdot');
                    cursor.find('.cursor-border').addClass('hide');
                    cursor.find('.cursor-glow').addClass('hide');
                    if (target.hasClass('footer-link')) cursor.find('.cursor-dot').addClass('whitedot');
                    targetPos = {
                        x: targetOffsetLeft + (0, _viewport.cvUnit)(-10, "rem"),
                        y: targetOffsetTop + targetValue.h / 2
                    };
                    updatePos();
                    break;
                case 'halostick':
                    cursor.find('.cursor-dot').addClass('smdot');
                    cursor.find('.cursor-border').addClass('hide');
                    cursor.find('.cursor-glow').addClass('hide');
                    gsap.to(target, {
                        x: (0, _viewport.cvUnit)(15, 'rem'),
                        duration: .6,
                        ease: 'power2.out',
                        overwrite: true
                    });
                    targetPos = {
                        x: targetOffsetLeft + (0, _viewport.cvUnit)(-10, "rem"),
                        y: targetOffsetTop + targetValue.h / 2
                    };
                    updatePos();
                    break;
                case 'btnstick':
                    cursor.find('.cursor-dot').removeClass('hide');
                    cursor.find('.cursor-glow').removeClass('hide');
                    cursor.find('.cursor-dot').addClass('smdot');
                    cursor.find('.cursor-border').addClass('hide');
                    gsap.to(target.find('.txt'), {
                        x: (0, _viewport.cvUnit)(15, 'rem') / 2,
                        duration: .6,
                        ease: 'power2.out',
                        overwrite: true
                    });
                    if (target.hasClass('btn-white')) cursor.find('.cursor-dot').addClass('whitedot');
                    else if (target.hasClass('btn-black')) cursor.find('.cursor-dot').addClass('whitedot');
                    else cursor.find('.cursor-dot').addClass('whitedot');
                    targetPos = {
                        x: txtOffsetLeft + (0, _viewport.cvUnit)(-15, "rem") + parseInt(target.find('.txt').css('paddingLeft')),
                        y: txtOffsetTop + target.height() / 2
                    };
                    updatePos();
                    break;
                case 'menuprog':
                    cursor.find('.cursor-dot').removeClass('hide');
                    cursor.find('.cursor-dot').removeClass('whitedot');
                    cursor.find('.cursor-dot').addClass('smdot');
                    cursor.find('.cursor-border').addClass('hide');
                    cursor.find('.cursor-glow').addClass('hide');
                    targetPos = {
                        x: targetOffsetLeft + targetValue.w / 2,
                        y: targetOffsetTop + targetValue.h / 2
                    };
                    updatePos();
                    break;
                case 'hamburger':
                    cursor.find('.cursor-dot').removeClass('whitedot');
                    cursor.find('.cursor-border').removeClass('hide');
                    cursor.find('.cursor-dot').addClass('hide');
                    cursor.find('.cursor-border').addClass('mddot');
                    cursor.find('.cursor-glow').addClass('hide');
                    targetPos = {
                        x: targetOffsetLeft + targetValue.w / 2,
                        y: targetOffsetTop + targetValue.h / 2
                    };
                    updatePos();
                    (0, _index.xSetter)(cursor.find('.cursor-border').get(0))((0, _index.lerp)(borderX, 0, velChange));
                    (0, _index.ySetter)(cursor.find('.cursor-border').get(0))((0, _index.lerp)(borderY, 0, velChange));
                    break;
            }
            cursorChange = true;
        } else {
            forcing = false;
            if (cursorChange == true) {
                // cursor.find('.cursor-border').css('width',widthCursor+'px'); // Giá trị ban đầu của width
                // cursor.find('.cursor-border').css('height', heightCursor+'px');
                cursor.closest('.cursor-wrap').removeClass('mixBlendMode');
                gsap.to('[data-cursor="btnstick"] .txt', {
                    x: 0,
                    duration: .6,
                    ease: 'power2.out'
                });
                gsap.to('[data-cursor="halostick"]', {
                    x: 0,
                    duration: .6,
                    ease: 'power2.out'
                });
                cursor.find('.cursor-dot').removeClass('stickstepdot');
                cursor.find('.cursor-dot').removeClass('hide');
                cursor.find('.cursor-dot').removeClass('smdot');
                cursor.find('.cursor-dot').removeClass('whitedot');
                cursor.find('.cursor-dot').removeClass('blackdot');
                cursor.find('.cursor-dot').removeClass('stickfaq');
                cursor.find('.cursor-dot').removeClass('stickService');
                cursor.find('.cursor-border').removeClass('stickstepdot');
                cursor.find('.cursor-border').removeClass('mddot');
                cursor.find('.cursor-border').removeClass('hide');
                cursor.find('.cursor-glow').removeClass('hide');
                cursorChange = false;
            }
            updatePos();
        }
        if ($('.home-portfolio:hover').length || $('.home-pricing-plan-item.popular:hover').length || $('.home-curtain:hover').length) {
            if (insideBgSc == false || cursorChange == false) {
                cursor.find('.cursor-dot').addClass('whitedot');
                insideBgSc = true;
            }
        } else if (insideBgSc == true) {
            cursor.find('.cursor-dot').removeClass('whitedot');
            insideBgSc = false;
        }
        requestAnimationFrame(initMouseMove);
    }
    if ($(window).width() > 991) initMouseMove();
};
exports.default = initCursor;

},{"../helper/index":"lOTX9","../helper/viewport":"e5DfO","@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"areWd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../helper/index");
var _viewport = require("../helper/viewport");
const initGlowBorder = ()=>{
    function dotRunAroundBorder() {
        const createElement = ()=>{
            $('[data-dot-glow-test]').each((idx, el)=>{
                const outerBorder = document.createElement('div');
                const innerBorder = document.createElement('div');
                $(outerBorder).addClass('border-dot-outer');
                $(innerBorder).addClass('border-dot-inner');
                $(outerBorder).append(innerBorder);
                $(outerBorder).css('borderRadius', parseFloat($(el).css("borderRadius")) + "px");
                $(el).prepend(outerBorder);
            });
        };
        const applyVariant = ()=>{
            const target = $('[data-dot-glow-test]');
            target.each((idx, el)=>{
                const element = $(el).find('.border-dot-outer');
                const target = $(el).find('.border-dot-inner');
                const radius = parseFloat($(el).css("borderRadius"));
                $(element).css('--border-radius', radius);
                const dimension = {
                    width: $(element).width(),
                    height: $(element).height()
                };
                const elRatio = dimension.width / dimension.height;
                $(element).css('--ratio-w', radius / dimension.width * 100);
                $(element).css('--ratio-h', radius / dimension.height * 100);
                //  Peripheral of Target
                const PeripCircle = Math.PI * 2 * radius;
                const LengthLongEdge = dimension.width - radius * 2;
                const LengthWideEdge = dimension.height - radius * 2;
                const PeripTarget = (LengthLongEdge + LengthWideEdge) * 2 + PeripCircle;
                const ratioLong = LengthLongEdge / PeripTarget;
                const ratioWide = LengthWideEdge / PeripTarget;
                const ratioPeripCircle = PeripCircle / PeripTarget;
                const tlItem = gsap.timeline({
                    repeat: -1
                });
                const duration = 5;
                console.log(LengthLongEdge / 2 / PeripTarget * duration);
                tlItem.to(target, {
                    x: dimension.width / 2 - radius,
                    y: 0,
                    duration: LengthLongEdge / 2 / PeripTarget * duration,
                    ease: "none"
                }).to(target, {
                    motionPath: {
                        type: "quadratic",
                        path: [
                            {
                                x: dimension.width / 2,
                                y: radius
                            }
                        ],
                        autoRotate: false
                    },
                    ease: "none",
                    duration: PeripCircle / 4 / PeripTarget * duration
                }).to(target, {
                    x: dimension.width / 2,
                    y: dimension.height - radius,
                    duration: LengthWideEdge / PeripTarget * duration,
                    ease: "none"
                }).to(target, {
                    motionPath: {
                        type: "quadratic",
                        path: [
                            {
                                x: dimension.width / 2 - radius,
                                y: dimension.height
                            }
                        ],
                        autoRotate: false
                    },
                    ease: "none",
                    duration: PeripCircle / 4 / PeripTarget * duration
                }).to(target, {
                    x: -dimension.width / 2 + radius,
                    y: dimension.height,
                    duration: LengthLongEdge / PeripTarget * duration,
                    ease: "none"
                }).to(target, {
                    motionPath: {
                        type: "quadratic",
                        path: [
                            {
                                x: -dimension.width / 2,
                                y: dimension.height - radius
                            }
                        ],
                        autoRotate: false
                    },
                    ease: "none",
                    duration: PeripCircle / 4 / PeripTarget * duration
                }).to(target, {
                    x: -dimension.width / 2,
                    y: radius,
                    duration: LengthWideEdge / PeripTarget * duration,
                    ease: "none"
                }).to(target, {
                    motionPath: {
                        type: "quadratic",
                        path: [
                            {
                                x: -dimension.width / 2 + radius,
                                y: 0
                            }
                        ],
                        autoRotate: false
                    },
                    ease: "none",
                    duration: PeripCircle / 4 / PeripTarget * duration
                }).to(target, {
                    x: 0,
                    y: 0,
                    duration: LengthLongEdge / 2 / PeripTarget * duration,
                    ease: "none"
                });
            // .to(target, {
            //     motionPath: {
            //         type: "quadratic",
            //         path: [
            //             {x:0, y:0},
            //             {x: dimension.width / 2 - radius, y: 0},
            //             {x: dimension.width / 2, y: radius},
            //             {x: dimension.width / 2, y: dimension.height - radius},
            //             {x: dimension.width / 2 - radius, y: dimension.height},
            //             {x: -dimension.width / 2 + radius, y: dimension.height},
            //             {x: -dimension.width / 2, y: dimension.height - radius},
            //             {x: -dimension.width / 2, y: radius},
            //             {x: -dimension.width / 2 + radius, y: 0},
            //             {x:0, y:0}
            //         ],
            //         autoRotate: false
            //       },
            //       ease: Linear.easeNone,
            //       duration: 5
            // })
            // const easeInOut = `cubic-bezier(1, 0.1, 0, 0.9)`
            // animation-timing-function: ${easeInOut}
            // const keyframes = `
            //     @keyframes DotAroundBorder {
            //         0% {
            //             top: 0%;
            //             left: 50%;
            //         }
            //         ${LengthLongEdge / 2 / PeripTarget * 100}% {
            //             top: 0%;
            //             left: ${100 - radius/dimension.width * 100}%;
            //             animation-timing-function: ${easeInOut}
            //         }
            //         ${(LengthLongEdge / 2 + PeripCircle / 4) / PeripTarget * 100}% {
            //             top: ${radius/dimension.height * 100}%;
            //             left: 100%;
            //         }
            //         ${(LengthLongEdge / 2 + PeripCircle / 4 + LengthWideEdge) / PeripTarget * 100}% {
            //             top: ${100 - radius/dimension.height * 100}%;
            //             left: 100%;
            //         }
            //         ${(LengthLongEdge / 2 + PeripCircle / 2 + LengthWideEdge) / PeripTarget * 100}% {
            //             top: 100%;
            //             left: ${100 - radius/dimension.width * 100}%;
            //         }
            //         ${(LengthLongEdge * 3 / 2 + PeripCircle / 2 + LengthWideEdge) / PeripTarget * 100}% {
            //             top: 100%;
            //             left: ${radius/dimension.width * 100}%;
            //         }
            //         ${(LengthLongEdge * 3 / 2 + PeripCircle * 3 / 4 + LengthWideEdge) / PeripTarget * 100}% {
            //             top: ${100 - radius/dimension.height * 100}%;
            //             left: 0%;
            //         }
            //         ${(LengthLongEdge * 3 / 2 + PeripCircle * 3 / 4 + LengthWideEdge * 2) / PeripTarget * 100}% {
            //             top: ${radius/dimension.height * 100}%;
            //             left: 0%;
            //         }
            //         ${(LengthLongEdge * 3 / 2 + PeripCircle + LengthWideEdge * 2) / PeripTarget * 100}% {
            //             top: 0%;
            //             left: ${radius/dimension.width * 100}%;
            //         }
            //         ${(LengthLongEdge * 2 + PeripCircle + LengthWideEdge * 2) / PeripTarget * 100}% {
            //             top: 0%;
            //             left: 50%;
            //         }
            //     }
            // `;
            // console.log(keyframes);
            // Create a style element and append it to the head
            // const styleSheet = document.createElement("style");
            // styleSheet.type = "text/css";
            // styleSheet.innerText = keyframes;
            // document.head.appendChild(styleSheet);
            // Apply the animation to the element
            // $(target).css('animation', 'DotAroundBorder 8s linear infinite');
            });
        };
        createElement();
        applyVariant();
    }
    // dotRunAroundBorder()
    function borderGlow() {
        const CreateGlowDiv = ()=>{
            $('[data-border-glow]').each((idx, el)=>{
                const option = JSON.parse($(el).attr('data-glow-option'));
                // Create Element
                const outerBorder = document.createElement('div');
                const innerBorder = document.createElement('div');
                const lineBorder = document.createElement('div');
                $(outerBorder).addClass('border-outer');
                $(innerBorder).addClass('border-inner');
                $(lineBorder).addClass('glow-el');
                const wrapOuterGlow = document.createElement('div');
                const innerOuterGlow = document.createElement('div');
                const elementOuterGlow = document.createElement('div');
                $(wrapOuterGlow).addClass('glow-outer');
                $(innerOuterGlow).addClass('glow-outer-inner');
                $(elementOuterGlow).addClass('glow-el');
                const wrapInnerGlow = document.createElement('div');
                const innerInnerGlow = document.createElement('div');
                const elementInnerGlow = document.createElement('div');
                $(wrapInnerGlow).addClass('glow-inner');
                $(innerInnerGlow).addClass('glow-inner-inner');
                $(elementInnerGlow).addClass('glow-el');
                // Set Border Radius for Border
                // $([outerBorder, wrapOuterGlow, wrapInnerGlow]).css('--border-radius', parseFloat($(el).css("borderRadius")) + "px")
                // Set Border Width for Border
                $([
                    outerBorder,
                    wrapOuterGlow,
                    wrapInnerGlow
                ]).css('--border-width', `${parseFloat(option.width) || 1}px`);
                //Set Inset for Border
                if (option.inset) {
                    if (!option.inset.x && !option.inset.y) {
                        $([
                            outerBorder,
                            wrapOuterGlow,
                            wrapInnerGlow
                        ]).css('width', `calc(100% - ${parseFloat(option.inset)}px)`);
                        $([
                            outerBorder,
                            wrapOuterGlow,
                            wrapInnerGlow
                        ]).css('height', `calc(100% - ${parseFloat(option.inset)}px)`);
                    }
                    if (option.inset.x) $([
                        outerBorder,
                        wrapOuterGlow,
                        wrapInnerGlow
                    ]).css('width', `calc(100% - ${parseFloat(option.inset.x)}px)`);
                    if (option.inset.y) $([
                        outerBorder,
                        wrapOuterGlow,
                        wrapInnerGlow
                    ]).css('height', `calc(100% - ${parseFloat(option.inset.y)}px)`);
                }
                $([
                    outerBorder,
                    wrapOuterGlow,
                    wrapInnerGlow
                ]).css('--opacity', option.opacity || 1);
                //Set Glow for Glow Dot
                if (option.glow > 10) $([
                    lineBorder,
                    elementOuterGlow,
                    elementInnerGlow
                ]).addClass('glow-big');
                else if (option.glow > 6) $([
                    lineBorder,
                    elementOuterGlow,
                    elementInnerGlow
                ]).addClass('glow-nor');
                $([
                    outerBorder,
                    wrapOuterGlow,
                    wrapInnerGlow
                ]).css('--glow', (option.glow || 4) + "rem");
                if (option.color === undefined) option.color = "rgba(255, 255, 255, 1)";
                $([
                    outerBorder,
                    wrapOuterGlow,
                    wrapInnerGlow
                ]).css('--bg-cl', option.color);
                if (option.position) $(lineBorder).addClass('force-cl');
                // Append Element
                $(innerBorder).append(lineBorder);
                $(outerBorder).append(innerBorder);
                $(innerOuterGlow).append(elementOuterGlow);
                $(wrapOuterGlow).append(innerOuterGlow);
                $(innerInnerGlow).append(elementInnerGlow);
                $(wrapInnerGlow).append(innerInnerGlow);
                if (!$(el).parents('[data-glow-option]').length && !option.position) {
                    $(el).prepend(wrapOuterGlow);
                    $(el).prepend(wrapInnerGlow);
                }
                $(el).prepend(outerBorder);
            });
        };
        const AnimDotGlow = ()=>{
            let target = $('[data-border-glow]');
            gsap.set(".border-inner, .glow-outer-inner, .glow-inner-inner", {
                opacity: 0
            });
            // console.log(target);
            function initDotGlow() {
                let targetPos = {
                    x: (0, _index.xGetter)('.cursor'),
                    y: (0, _index.yGetter)('.cursor')
                };
                target.each((idx, el)=>{
                    let isGetData = false;
                    let option;
                    let borderTarget;
                    let glowOuter;
                    let glowInner;
                    if (!isGetData) {
                        option = JSON.parse($(el).attr('data-glow-option'));
                        borderTarget = $(el).find(".border-inner");
                        glowOuter = $(el).find(".glow-outer-inner");
                        glowInner = $(el).find(".glow-inner-inner");
                        isGetData = true;
                    }
                    let xBorderTarget = (0, _index.xGetter)(borderTarget.get(0));
                    let yBorderTarget = (0, _index.yGetter)(borderTarget.get(0));
                    let xGlowOuter = (0, _index.xGetter)(glowOuter.get(0));
                    let yGlowOuter = (0, _index.yGetter)(glowOuter.get(0));
                    let xGlowInner = (0, _index.xGetter)(glowInner.get(0));
                    let yGlowInner = (0, _index.yGetter)(glowInner.get(0));
                    // Move with Cursor
                    const MagicMath = ()=>{
                        // Calculate Glow Dot Move
                        const maxXMove = $(el).outerWidth() / 2;
                        const maxYMove = $(el).outerHeight() / 2;
                        let xMove = targetPos.x - (el.getBoundingClientRect().left + $(el).outerWidth() / 2);
                        let yMove = targetPos.y - (el.getBoundingClientRect().top + $(el).outerHeight() / 2);
                        let limitBorderXMove = Math.max(Math.min(xMove, maxXMove), -maxXMove);
                        let limitBorderYMove = Math.max(Math.min(yMove, maxYMove), -maxYMove);
                        let limitGlowOuterXMove = Math.max(Math.min(xMove, maxXMove - parseFloat($(el).css("borderRadius"))), -(maxXMove - parseFloat($(el).css("borderRadius"))));
                        let limitGlowOuterYMove = Math.max(Math.min(yMove, maxYMove - parseFloat($(el).css("borderRadius"))), -(maxYMove - parseFloat($(el).css("borderRadius"))));
                        let GlowInnerXMove;
                        let GlowInnerYMove;
                        // Calculate Magnetic Area
                        let boundingMagnet = {
                            top: el.getBoundingClientRect().top - (0, _viewport.cvUnit)(option.magnetic * 10 / 2 || 0, "rem"),
                            right: el.getBoundingClientRect().right + (0, _viewport.cvUnit)(option.magnetic * 10 / 2 || 0, "rem"),
                            bottom: el.getBoundingClientRect().bottom + (0, _viewport.cvUnit)(option.magnetic * 10 / 2 || 0, "rem"),
                            left: el.getBoundingClientRect().left - (0, _viewport.cvUnit)(option.magnetic * 10 / 2 || 0, "rem")
                        };
                        const changeOpacityTarget = [
                            borderTarget
                        ];
                        if (glowOuter.length) {
                            changeOpacityTarget.push(glowOuter);
                            changeOpacityTarget.push(glowInner);
                        }
                        // Anim opacity
                        const changeOpacity = {
                            change: ()=>{
                                let opacityTarget = (0, _index.opacityGetter)(borderTarget.get(0));
                                if (borderTarget.hasClass('active')) {
                                    let xOffset = Math.abs(xMove) - maxXMove;
                                    let yOffset = Math.abs(yMove) - maxYMove;
                                    let xNormalize = Math.min(Math.abs((Math.abs(xMove) - $(el).outerWidth() / 2) / (0, _viewport.cvUnit)(option.magnetic * 10 / 2 || 1, "rem") - 1), 1) // Run 0 - 1
                                    ;
                                    let yNormalize = Math.min(Math.abs((Math.abs(yMove) - $(el).outerHeight() / 2) / (0, _viewport.cvUnit)(option.magnetic * 10 / 2 || 1, "rem") - 1), 1) // Run 0 - 1
                                    ;
                                    if (xOffset > 0 && yOffset > 0) {
                                        if (xOffset <= yOffset) // Opacity Set by Y Pos
                                        $(changeOpacityTarget).each((idx, el)=>{
                                            (0, _index.opacitySetter)(el)((0, _index.lerp)(opacityTarget, yNormalize * 1.15, .95));
                                        });
                                        else // Opacity Set by X Pos
                                        $(changeOpacityTarget).each((idx, el)=>{
                                            (0, _index.opacitySetter)(el)((0, _index.lerp)(opacityTarget, xNormalize * 1.15, .95));
                                        });
                                    } else {
                                        if (xOffset <= 0) // Opacity Set by Y Pos
                                        $(changeOpacityTarget).each((idx, el)=>{
                                            (0, _index.opacitySetter)(el)((0, _index.lerp)(opacityTarget, yNormalize * 1.15, .95));
                                        });
                                        if (yOffset <= 0) // Opacity Set by X Pos
                                        $(changeOpacityTarget).each((idx, el)=>{
                                            (0, _index.opacitySetter)(el)((0, _index.lerp)(opacityTarget, xNormalize * 1.15, .95));
                                        });
                                        if (xOffset <= 0 && yOffset <= 0) // This is Hovering
                                        $(changeOpacityTarget).each((idx, el)=>{
                                            (0, _index.opacitySetter)(el)((0, _index.lerp)(opacityTarget, 1, .95));
                                        });
                                    }
                                }
                            },
                            default: ()=>{
                                gsap.set(changeOpacityTarget, {
                                    opacity: 0
                                });
                            },
                            visible: ()=>{
                                gsap.set(changeOpacityTarget, {
                                    opacity: 1
                                });
                            }
                        };
                        // Check target in magnetic area yet
                        if (!option.position) {
                            if (boundingMagnet.left <= targetPos.x && targetPos.x <= boundingMagnet.right && boundingMagnet.top <= targetPos.y && targetPos.y <= boundingMagnet.bottom) {
                                //Anim Border
                                borderTarget.addClass('active');
                                (0, _index.xSetter)(borderTarget.get(0))((0, _index.lerp)(xBorderTarget, limitBorderXMove, .55));
                                (0, _index.ySetter)(borderTarget.get(0))((0, _index.lerp)(yBorderTarget, limitBorderYMove, .55));
                                (0, _index.xSetter)(glowOuter.get(0))((0, _index.lerp)(xGlowOuter, xMove, .55));
                                (0, _index.ySetter)(glowOuter.get(0))((0, _index.lerp)(yGlowOuter, yMove, .55));
                                (0, _index.xSetter)(glowInner.get(0))((0, _index.lerp)(xGlowInner, xMove, .55));
                                (0, _index.ySetter)(glowInner.get(0))((0, _index.lerp)(yGlowInner, yMove, .55));
                                changeOpacity.change();
                            } else {
                                // Reset Border and Glow Position
                                borderTarget.removeClass('active');
                                (0, _index.xSetter)(borderTarget.get(0))((0, _index.lerp)(xBorderTarget, limitBorderXMove, .55));
                                (0, _index.ySetter)(borderTarget.get(0))((0, _index.lerp)(yBorderTarget, limitBorderYMove, .55));
                                (0, _index.xSetter)(glowOuter.get(0))((0, _index.lerp)(xGlowOuter, xMove, .55));
                                (0, _index.ySetter)(glowOuter.get(0))((0, _index.lerp)(yGlowOuter, yMove, .55));
                                (0, _index.xSetter)(glowInner.get(0))((0, _index.lerp)(xGlowInner, xMove, .55));
                                (0, _index.ySetter)(glowInner.get(0))((0, _index.lerp)(yGlowInner, yMove, .55));
                                changeOpacity.default();
                            }
                        }
                        /// Check State Position of this border
                        if (option.position) {
                            if (boundingMagnet.left <= targetPos.x && targetPos.x <= boundingMagnet.right && boundingMagnet.top <= targetPos.y && targetPos.y <= boundingMagnet.bottom) {
                                // Anim
                                (0, _index.xSetter)(borderTarget.get(0))((0, _index.lerp)(xBorderTarget, limitBorderXMove, .1));
                                (0, _index.ySetter)(borderTarget.get(0))((0, _index.lerp)(yBorderTarget, limitBorderYMove, .1));
                                (0, _index.xSetter)(glowOuter.get(0))((0, _index.lerp)(xGlowOuter, limitBorderXMove, .15));
                                (0, _index.ySetter)(glowOuter.get(0))((0, _index.lerp)(yGlowOuter, limitBorderYMove, .15));
                                (0, _index.xSetter)(glowInner.get(0))((0, _index.lerp)(xGlowInner, limitBorderXMove, .15));
                                (0, _index.ySetter)(glowInner.get(0))((0, _index.lerp)(yGlowInner, limitBorderYMove, .15));
                                changeOpacity.visible();
                            } else {
                                // Reset Border and Glow Position
                                changeOpacity.visible();
                                (0, _index.xSetter)(borderTarget.get(0))((0, _index.lerp)(xBorderTarget, 0, .05));
                                (0, _index.ySetter)(borderTarget.get(0))((0, _index.lerp)(yBorderTarget, 0, .05));
                                (0, _index.xSetter)(glowOuter.get(0))((0, _index.lerp)(xGlowOuter, 0, .05));
                                (0, _index.ySetter)(glowOuter.get(0))((0, _index.lerp)(yGlowOuter, 0, .05));
                                (0, _index.xSetter)(glowInner.get(0))((0, _index.lerp)(xGlowInner, 0, .05));
                                (0, _index.ySetter)(glowInner.get(0))((0, _index.lerp)(yGlowInner, 0, .05));
                                // Check State Position of this border
                                const pos = option.position.split(" ");
                                $(pos).each((idx, posTarget)=>{
                                    switch(posTarget){
                                        case 'top':
                                            (0, _index.ySetter)(borderTarget.get(0))((0, _index.lerp)(yBorderTarget, -maxYMove, .05));
                                            (0, _index.ySetter)(glowOuter.get(0))((0, _index.lerp)(yGlowOuter, -maxYMove, .05));
                                            (0, _index.ySetter)(glowInner.get(0))((0, _index.lerp)(yGlowInner, -maxYMove, .05));
                                            break;
                                        case 'bottom':
                                            (0, _index.ySetter)(borderTarget.get(0))((0, _index.lerp)(yBorderTarget, maxYMove, .05));
                                            (0, _index.ySetter)(glowOuter.get(0))((0, _index.lerp)(yGlowOuter, maxYMove, .05));
                                            (0, _index.ySetter)(glowInner.get(0))((0, _index.lerp)(yGlowInner, maxYMove, .05));
                                            break;
                                        case 'left':
                                            (0, _index.xSetter)(borderTarget.get(0))((0, _index.lerp)(xBorderTarget, -maxXMove, .05));
                                            (0, _index.xSetter)(glowOuter.get(0))((0, _index.lerp)(xGlowOuter, -maxXMove, .05));
                                            (0, _index.xSetter)(glowInner.get(0))((0, _index.lerp)(xGlowInner, -maxXMove, .05));
                                            break;
                                        case 'right':
                                            (0, _index.xSetter)(borderTarget.get(0))((0, _index.lerp)(xBorderTarget, maxXMove, .05));
                                            (0, _index.xSetter)(glowOuter.get(0))((0, _index.lerp)(xGlowOuter, maxXMove, .05));
                                            (0, _index.xSetter)(glowInner.get(0))((0, _index.lerp)(xGlowInner, maxXMove, .05));
                                            break;
                                    }
                                });
                            }
                        }
                    };
                    if ((0, _index.inView)(el)) MagicMath();
                });
                requestAnimationFrame(initDotGlow);
            }
            requestAnimationFrame(initDotGlow);
        };
        if ($(window).width() > 991) {
            CreateGlowDiv();
            AnimDotGlow();
        }
    }
    borderGlow();
};
exports.default = initGlowBorder;

},{"../helper/index":"lOTX9","../helper/viewport":"e5DfO","@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"afhgQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lenis = require("./lenis");
var _viewport = require("../helper/viewport");
const initButton = ()=>{
    $(".btn").each((_, el)=>{
        let bgOverlay = $("<div></div>").addClass("btnoverlay");
        $(el).append(bgOverlay);
    });
    $("a.btn").each((_, item)=>{
        let href = $(item).attr("href");
        if (href.startsWith("./")) href = href.slice(2);
        $(item).attr("href", `${origin}/${href}`);
    });
    $("a.btn").on("click", function(e) {
        const url = new URL($(this).attr("href"));
        if (url.pathname === window.location.pathname) {
            if (url.hash) {
                e.preventDefault();
                let target = url.hash.replace("#", "");
                if ($("html").hasClass("lenis-smooth")) requestAnimationFrame(()=>(0, _lenis.lenis).scrollTo(`[id="${target}"]`));
                else {
                    //update later
                    let targetTop = $(`[id="${target}"]`).offset().top;
                    $("html, body").animate({
                        scrollTop: targetTop
                    });
                }
                history.replaceState({}, "", `${window.location.pathname}${url.hash}`);
                return false;
            }
        }
    });
    if (window.location.hash) {
        let target = window.location.hash.replace("#", "");
        if ($("html").hasClass("lenis-smooth")) requestAnimationFrame(()=>(0, _lenis.lenis).scrollTo(`[id="${target}"]`));
        else {
            //update later
            let targetTop = $(`[id="${target}"]`).get(0).offsetTop + $(window).height();
            $("html").animate({
                scrollTop: targetTop
            });
        }
    }
};
exports.default = initButton;

},{"./lenis":"2RIXr","../helper/viewport":"e5DfO","@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}],"b2BNP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../helper/index");
const refreshOnBreakpoint = ()=>{
    let initialViewportWidth = window.innerWidth || document.documentElement.clientWidth;
    let newViewportWidth;
    // portrait mobile viewport initial, any change refresh
    if (initialViewportWidth < 480) $(window).on('resize', (0, _index.debounce)(function() {
        newViewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (newViewportWidth > 479) location.reload();
    }));
    else if (initialViewportWidth < 768) $(window).on('resize', (0, _index.debounce)(function() {
        newViewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (newViewportWidth > 767) location.reload();
    }));
    else if (initialViewportWidth > 767 && initialViewportWidth < 992) $(window).on('resize', (0, _index.debounce)(function() {
        newViewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (newViewportWidth < 768 || newViewportWidth > 991) location.reload();
    }));
    else if (initialViewportWidth > 991) $(window).on('resize', (0, _index.debounce)(function() {
        newViewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (newViewportWidth < 992) location.reload();
    }));
};
exports.default = refreshOnBreakpoint;

},{"../helper/index":"lOTX9","@parcel/transformer-js/src/esmodule-helpers.js":"3toiX"}]},["37CyT"], "37CyT", "parcelRequirea9a6", {})

//# sourceMappingURL=repo.4195c4ba.js.map
